const translations = {};

translations["MSG_GUIDE"] = "Guide";
translations["MSG_NETWORK_ERROR_MESSAGE"] = "Could not display the page.\nPlease try again.";
translations["MSG_APP_ALL"] = "All";
translations["MSG_APP_BANNER_TITLE"] = "Manande Puzzle App";
translations["MSG_APP_BANNER_SUBTITLE"] = "~ Fun Programming Education for Kids ~";
translations["MSG_APP_BANNER_INSTALL_BTN"] = "Install";
translations["MSG_APP_BANNER_SHOW_BTN"] = "Show";

translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] = "Updating the app to the latest version.";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "A new version of the app is available.\nAn update is required to use the latest features.\nThe update will complete shortly.";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] =
  "Please enter a password of 6 characters or more.";
translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] = "Passwords do not match.";
translations["MSG_SIGN_IN_BTN"] = "Log In";
translations["MSG_SIGN_UP_BTN"] = "Sign Up";
translations["MSG_SIGN_IN_WITH_APPLE"] = "Continue with Apple";
translations["MSG_SIGN_UP_WITH_APPLE"] = "Continue with Apple";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "Continue with Google";
translations["MSG_SIGN_IN_WITH_MAIL"] = "Log In with Email";
translations["MSG_SIGN_UP_WITH_MAIL"] = "Sign Up with Email";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "Don't have an account? Sign up";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] = "Already have an account? Log in";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "Please enter your password";
translations["MSG_SIGN_LOGIN_FAILED"] =
  "Login failed. Please check your email address and password.";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "Passwords do not match";
translations["MSG_SIGN_UP_FAILED"] = "Account creation failed. Please try again.";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "Please enter your email address";
translations["MSG_SIGN_EMAIL_INVALID"] = "Please enter a valid email address";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] =
  "Failed to send password reset email. Please try again.";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] =
  "※We will send a password reset link to your registered email address.";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "Send Reset Email";
translations["MSG_SIGN_EMAIL_SENT"] = "Email sent";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] =
  "Password reset link has been sent.\nPlease check your email.";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "Back to Login";
translations["MSG_USER_NAME_LENGTH_LIMIT"] = "Please enter a name within 10 characters";
translations["MSG_USER_NAME_REQUIRED"] = "Please enter your name";
translations["MSG_USER_LATEST"] = "Latest";
translations["MSG_USER_LIST"] = "Player List";
translations["MSG_USER_START_LEARNING_MESSAGE"] =
  "To start learning,\nplease create an account first.";
translations["MSG_USER_ADD_CHILD_ACCOUNT"] = "Add Child Account";
translations["MSG_USER_START"] = "Start";
translations["MSG_SIGN_USER_MAIL"] = "Email Address";
translations["MSG_SIGN_USER_PASSWORD"] = "Password";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "Re-enter Password";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "Login successful.";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "Account registration successful.";
// ReAuth
translations["MSG_REAUTH_TITLE"] = "Identity Verification";
translations["MSG_REAUTH_SSO_MESSAGE"] = "Please sign in again to continue";
translations["MSG_REAUTH_PASSWORD_RESET_CONFIRM"] =
  "A password reset email will be sent to the following address";
translations["MSG_REAUTH_BACK"] = "Back";
translations["MSG_BTN_LATER"] = "Later";
translations["MSG_BTN_CLOSE"] = "Close";

// Restricted Feature Dialog (Unified)
translations["MSG_RESTRICTED_FEATURE_TITLE_COURSE"] = "Cannot play courses";
translations["MSG_RESTRICTED_FEATURE_TITLE_PROJECT_LIMIT"] = "Cannot make apps";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_PROJECT_LIMIT"] =
  "The 「%{plan}」 allows up to %{limit} apps.\nChoose another plan to make more.<br>Ask your parents.";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHILD_USER_LIMIT"] = "Cannot add players";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHILD_USER_LIMIT"] =
  "The 「%{plan}」 allows up to %{limit} players.\nChoose another plan to add more.<br>Ask your parents.";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_CHAT_LIMIT"] = "Cannot send messages";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_CHAT_LIMIT"] =
  "The 「%{plan}」 allows sending %{limit} times per day.\nChoose another plan to send more.<br>Ask your parents.";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_IMAGE_LIMIT"] = "Cannot make images";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_IMAGE_LIMIT"] =
  "The 「%{plan}」 allows making %{limit} times per day.\nChoose another plan to make more.<br>Ask your parents.";
translations["MSG_RESTRICTED_FEATURE_TITLE_ASSET_LIMIT"] = "Cannot save assets";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_ASSET_LIMIT"] =
  "The 「%{plan}」 allows up to %{limit} of assets.\nChoose another plan to save more.<br>Ask your parents.";
translations["MSG_RESTRICTED_FEATURE_BTN_VIEW_PLANS"] = "Choose a Plan";

// Upgrade Promotion
translations["MSG_UPGRADE_PROMOTION_TITLE"] = "Upgrade your plan and enjoy more!";
translations["MSG_UPGRADE_MODAL_TITLE"] = "Choose a Plan";
translations["MSG_UPGRADE_MODAL_SUBTITLE"] = "Please consider a plan that fits your child's usage.";
translations["MSG_UPGRADE_MODAL_CURRENT_PLAN"] = "Current Plan";
translations["MSG_UPGRADE_PROMOTION_RECOMMENDED"] = "Recommended";
translations["MSG_UPGRADE_PROMOTION_TABLE_PLAN"] = "Plan";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS"] = "Child Players";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_TRIAL"] = "1";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_FREE"] = "2";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_STANDARD"] = "4";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_PREMIUM"] = "8";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS"] = "Projects";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_TRIAL"] = "1";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_FREE"] = "5";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_STANDARD"] = "10";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_PREMIUM"] = "10";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE"] = "AI Image";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_TRIAL"] = "1/day";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_FREE"] = "2/day";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_STANDARD"] = "10/day";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_PREMIUM"] = "Unlimited\n(3 at a time)";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT"] = "AI Assistant";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_TRIAL"] = "4/day";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_FREE"] = "8/day";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_STANDARD"] = "Unlimited";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_PREMIUM"] = "Unlimited";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE"] = "Data Storage";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_TRIAL"] = "100MB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_FREE"] = "1GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_STANDARD"] = "5GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_PREMIUM"] = "50GB";
translations["MSG_PLAN_CHANGE_BTN"] = "Change Plan";
translations["MSG_UPGRADE_PROMOTION_CHANGE_BTN"] = "Change";
translations["MSG_UPGRADE_PROMOTION_TRIAL_DESCRIPTION"] =
  "Register an account to subscribe to paid plans";
translations["MSG_UPGRADE_PROMOTION_FREE_DESCRIPTION"] =
  "You can change your plan on the parent page";
translations["MSG_UPGRADE_PROMOTION_LATER_BTN"] = "Later";
translations["MSG_UPGRADE_PROMOTION_SIGNUP_BTN"] = "Register Account";
translations["MSG_UPGRADE_PROMOTION_UPGRADE_BTN"] = "Go to Parent Page";
translations["MSG_UPGRADE_PROMOTION_BTN_REGISTER"] = "Register";
translations["MSG_UPGRADE_PROMOTION_BTN_PURCHASE"] = "Purchase";

translations["MSG_SIGN_IN_FAILED_TITLE"] = "Login Failed";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] = "Incorrect email address or password.";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "Forgot Password?";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "Password Reset";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] = "Current Password";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "New Password";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] = "Confirm Password";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] = "Password changed successfully.";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] = "Incorrect password entered.";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] =
  "This email address is already in use.";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "Parent";

translations["MSG_DATETIME_PERIOD"] = "Period";
translations["MSG_DATETIME_PERIOD_RECENTLY"] = "Recently";
// Example US format
translations["MSG_DATETIME_FORMAT_HOUR"] = "hr";
translations["MSG_DATETIME_FORMAT_MINUTE"] = "min";

translations["MSG_INEXUS_OFFICIAL"] = "Manande Puzzle";
translations["MSG_INEXUS_OFFICIAL_CONTACT"] = "Manapuzzle Support";
translations["MSG_AI_CHAT_SESSION_START"] = "New Chat";
translations["MSG_AI_CHAT_SESSION_END"] = "Chat Ended";
translations["MSG_REVIEW_RATING_TITLE"] = "Please rate\n'Manande Puzzle'\nfor us!";
translations["MSG_REVIEW_FEEDBACK_TITLE"] = "Suggestion Box";
translations["MSG_REVIEW_SEND_RATING_CONFIRM"] = "Send";
translations["MSG_REVIEW_SEND_FEEDBACK_CONFIRM"] = "Send Feedback";
translations["MSG_REVIEW_THANKS_BUBBLE_TEXT"] = "Thank you\nvery much!";
translations["MSG_REVIEW_FEEDBACK_THANKS_TEXT"] =
  "We look forward to your continued\nsupport of 'Manande Puzzle'.";

translations["MSG_REVIEW_FEEDBACK_TYPE_APP"] = "Entire App";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE"] = "'Learn with Courses'";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR"] = "'Create Freely'";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "No complaints";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] = "Don't know\nhow to use";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "Difficult to use";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "Too difficult";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "Too easy";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "Too many\nstages";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "Too few\nstages";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] = "Can't create\nwell";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] = "Difficult to\nuse";
translations["MSG_REVIEW_FEEDBACK_PLACEHOLDER"] = "Write freely here";
translations["MSG_USER_PROFILE_ADD_USER_BTN"] = "Add";
translations["MSG_USER_PROFILE_CHANGE_USER"] = "Switch Player";
translations["MSG_USER_PROFILE_CHANGE_USER_TITLE"] = "Switch player?";
translations["MSG_USER_PROFILE_CHANGE_USER_MESSAGE"] = 'Switch to "%{name}".';
translations["MSG_USER_PROFILE_CHANGE_USER_SUCCESS"] = "Switched player.";
translations["MSG_USER_PROFILE_CHANGE_USER_FAILED"] = "Failed to switch player.";
translations["MSG_USER_PROFILE_MAX_USER_TITLE"] = "Cannot Add Player";
translations["MSG_USER_PROFILE_MAX_USER_MESSAGE"] =
  "Your current plan allows up to %{limit} players\nTo add a new player, please delete an existing one";
translations["MSG_USER_PROFILE_ADD_USER_DISABLED_TITLE"] = "Can't add here";
translations["MSG_USER_PROFILE_ADD_USER_DISABLED_MESSAGE"] =
  "・Only parents/guardians can add players.\n・If you want to add a player, please ask your parent/guardian to add one from the parent page.";
translations["MSG_USER_PROFILE_SHOW_USER_LIST_BTN"] = "More";
translations["MSG_USER_PROFILE_USER_STATUS"] = "Status";
translations["MSG_USER_SELECTION_PROMPT"] = "Choose a player";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "Name%{random}";
translations["MSG_USER_PROFILE_FIELD_NAME"] = "Nickname";
translations["MSG_USER_PROFILE_FIELD_NAME_PLACEHOLDER"] = "Enter nickname";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT"] = "Give yourself a name";
translations["MSG_USER_PROFILE_FIELD_GENDER"] = "Gender";
translations["MSG_USER_PROFILE_FIELD_GENDER_MALE"] = "Male";
translations["MSG_USER_PROFILE_FIELD_GENDER_FEMALE"] = "Female";
translations["MSG_USER_PROFILE_FIELD_GENDER_NONE"] = "None";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY"] = "Birthday";
translations["MSG_USER_PROFILE_STATUS_COURSE_CLEARED"] = "Courses\nCleared";
translations["MSG_USER_PROFILE_STATUS_PROJECTS"] = "Apps\nCreated";
translations["MSG_USER_PROFILE_STATUS_PUBLISHED_PROJECTS"] = "Apps\nPublished";
translations["MSG_USER_PROFILE_STATUS_PROJECT_RECEIVED_FAVORITE"] = "Likes\nReceived";
translations["MSG_USER_PROFILE_STATUS_DAYS_SINCE_JOIN"] = "Member\nFor";
translations["MSG_USER_PROFILE_STATUS_DAYS_UNIT"] = "%{count}d";
translations["MSG_USER_PROFILE_STATUS_PLAN"] = "Plan";
translations["MSG_USER_TAB_PROGRESS"] = "Learning";
translations["MSG_USER_TAB_STOCK"] = "Items";
translations["MSG_USER_TAB_PLAN"] = "Plan";
translations["MSG_USER_PLAN_CURRENT"] = "In Use";
translations["MSG_USER_PLAN_USAGE"] = "Usage";
translations["MSG_USER_PLAN_CHANGE"] = "Change Plan";
translations["MSG_USER_PLAN_PROJECTS"] = "Projects";
translations["MSG_USER_PLAN_AI_CHAT"] = "AI Chat";
translations["MSG_USER_PLAN_AI_IMAGE"] = "AI Images";
translations["MSG_USER_PLAN_UNLIMITED"] = "Unlimited";
translations["MSG_USER_PLAN_HERO_INCLUDED"] = "What's Included";
translations["MSG_USER_PLAN_HERO_TAGLINE_TRIAL"] = "Try it out!";
translations["MSG_USER_PLAN_HERO_TAGLINE_FREE"] = "Play for free";
translations["MSG_USER_PLAN_HERO_TAGLINE_STANDARD"] = "Make more";
translations["MSG_USER_PLAN_HERO_TAGLINE_PREMIUM"] = "Make anything!";
translations["MSG_USER_PLAN_HERO_TAGLINE_BUILDER"] = "Build maps too!";
translations["MSG_USER_PLAN_HERO_TAGLINE_EDUCATION"] = "Learn together";
translations["MSG_USER_PLAN_UPGRADE_CARD_TITLE"] = "More fun plans available";
translations["MSG_USER_PLAN_UPGRADE_COMPARE_HEADER_NOW"] = "Now";
translations["MSG_USER_PLAN_UPGRADE_COMPARE_HEADER_NEXT"] = "After Upgrade";
translations["MSG_USER_PLAN_BILLING_MONTHLY"] = "Monthly";
translations["MSG_USER_PLAN_BILLING_ANNUAL"] = "Yearly";
translations["MSG_USER_PLAN_BILLING_ANNUAL_DEAL"] = "Save 2 months!";
translations["MSG_USER_PLAN_BILLING_ANNUAL_DEAL_BADGE"] = "Save 2mo!";
translations["MSG_USER_PLAN_PRICE_PER_MONTH"] = "/mo";
translations["MSG_USER_PLAN_PRICE_PER_YEAR"] = "/yr";
translations["MSG_USER_PLAN_UPGRADE_BTN"] = "Upgrade Now";
translations["MSG_USER_PLAN_VIEW_ALL_PLANS"] = "See all plans";
translations["MSG_USER_PLAN_UPDATE_REQUIRED_TITLE"] = "App Update Required";
translations["MSG_USER_PLAN_UPDATE_REQUIRED_MESSAGE"] = "Please update to the latest version";
translations["MSG_USER_PLAN_AMAZON_NOT_SUPPORTED_TITLE"] = "Not Available";
translations["MSG_USER_PLAN_AMAZON_NOT_SUPPORTED_MESSAGE"] = "Purchase is not available on Amazon";
translations["MSG_USER_PLAN_PURCHASE_SUCCESS"] = "Upgrade complete!";
translations["MSG_USER_PLAN_PURCHASE_ERROR"] = "Something went wrong. Please try again";
translations["MSG_USER_PLAN_AMAZON_OK_BTN"] = "OK";
translations["MSG_USER_PLAN_AI_IMAGE_PER_REQUEST"] = "Per gen";
translations["MSG_USER_PLAN_AI_IMAGE_CREATE_COUNT"] = "Generations";
translations["MSG_USER_PLAN_AI_IMAGE_SIMULTANEOUS_COUNT"] = "Per request";
translations["MSG_USER_PLAN_ASSETS"] = "Storage";
translations["MSG_USER_PLAN_SUBTAB_CURRENT"] = "Usage\nStatus";
translations["MSG_USER_PLAN_SUBTAB_PURCHASE"] = "Buy a\nPlan";
translations["MSG_USER_PLAN_COMPARE_HEADER_CURRENT"] = "Now";
translations["MSG_USER_PLAN_INACTIVE_NOTICE"] = "You have access to all features!";
translations["MSG_USER_PLAN_CARD_CURRENT_BADGE"] = "Current Plan";
translations["MSG_USER_PLAN_PRICE_FREE"] = "¥0";
translations["MSG_USER_PLAN_GOTO_PURCHASE"] = "Upgrade your Plan";
translations["MSG_USER_PLAN_BUY_BTN"] = "Choose this plan";
translations["MSG_USER_PLAN_REGISTER_BTN"] = "Register";
translations["MSG_USER_PLAN_COMPARE_SAME"] = "same";
translations["MSG_USER_PLAN_COMPARE_UNLOCK"] = "unlock!";
translations["MSG_USER_PLAN_TIMES_SUFFIX"] = "x";
translations["MSG_USER_PLAN_USAGE_CARD_TITLE"] = "Usage";
translations["MSG_USER_PLAN_USAGE_CARD_SUBTITLE"] = "Today's activity";
translations["MSG_USER_PLAN_UPGRADE_PREVIEW_TITLE"] = "After upgrading";
translations["MSG_USER_PLAN_UPGRADE_PREVIEW_SUBTITLE"] = "You can do so much more!";
translations["MSG_USER_PLAN_UNIT_PIECES"] = "";
translations["MSG_USER_PLAN_UNIT_TIMES"] = "";
translations["MSG_USER_PLAN_UNIT_SHEETS"] = "";
translations["MSG_USER_PLAN_PERIOD_DAILY"] = "/day ";
translations["MSG_USER_PROFILE_PROGRESS"] = "Record";
translations["MSG_USER_PROFILE_PROGRESS_NEW_TITLE"] = "New!";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_LEVEL_TITLE"] = "Level";
translations["MSG_USER_PROFILE_PROGRESS_COURSE"] = "Learn with\nCourses";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_BTN"] = "Cleared\nCourses";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CHART_DATE_TITLE"] = "Day";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_TITLE"] = "Number Cleared";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR"] = "Create\nFreely";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_BTN"] = "My\nWorks";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_START"] = "Total";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_END"] = "People";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_START"] = "Total";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_END"] = "Likes";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_VIEWED_TITLE"] = "Visitors";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_FAVORITED_TITLE"] = "Likes";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY"] = "No works yet";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY_DESC"] =
  "Play in Create Freely and they'll line up here";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_GOTO_BTN"] = "Go to 'Create Freely'";
translations["MSG_USER_PROFILE_INFO"] = "Me";
translations["MSG_USER_PROFILE_ICON_BTN"] = "Change Icon";
translations["MSG_USER_PROFILE_CASE_BTN"] = "Change Case";
translations["MSG_USER_PROFILE_STOCK"] = "Materials";
translations["MSG_USER_PROFILE_SETTING"] = "Settings";
translations["MSG_USER_PROFILE_NAME_ERROR_TITLE"] = "Registration failed.";
translations["MSG_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "Contains unusable characters or text. Please try again.";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_TITLE"] = "Registration failed.";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "Contains unusable characters or text. Please try again.";
translations["MSG_USER_PROFILE_MESSAGE"] = "Mail";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_TITLE"] = "%{type} Inquiry";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"] =
  "Thank you for your inquiry!\nPlease write your question in the input field below.";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_INPUT_AUTO_REPLY"] =
  translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"];
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_TALK_WELCOME_TEXT"] = " joined.";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_SEND_BTN"] = "Send";
translations["MSG_USER_PROFILE_MESSAGE_MENU"] = "Menu";

// Official welcome messages (dynamic index 0..3)
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_0"] =
  "%{name}, welcome to 'Manande Puzzle'!";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_1"] =
  "In 'Manande Puzzle', you can learn programming while having fun playing puzzles.\nFirst, try starting with 'Learn with Courses' to learn how to play and study in order!";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_2"] =
  "Once you have a general understanding of algorithms and programming methods, try creating your own app as you like in 'Create Freely'.";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_3"] = "Let's try 'Manande Puzzle'!";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING"] = " sent a rating.";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING_AUTO_REPLY"] = "Thank you for your rating!";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_AUTO_REPLY"] =
  "Thank you for your feedback!";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TITLE"] = "Feedback";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TYPE_OTHER"] = "・Other:";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_PLACEHOLDER"] = "Write freely here";
translations["MSG_USER_PROFILE_MESSAGE_PUBLISHED_PROJECT_MESSAGE"] = 'Published the app "%{name}".';

translations["MSG_USER_DASHBOARD_TITLE"] = "Dashboard";
translations["MSG_USER_DASHBOARD_VIEW_FULL_PAGE"] = "Open\nMy Page";
translations["MSG_USER_DASHBOARD_UNREAD"] = "unread";
translations["MSG_USER_DASHBOARD_NO_UNREAD"] = "No new messages";
translations["MSG_DASHBOARD_SWITCH_PLAYER"] = "Switch\nPlayer";
translations["MSG_DASHBOARD_ADD_PLAYER"] = "Add\nPlayer";
translations["MSG_DASHBOARD_CHANGE_PLAN"] = "Change\nPlan";
translations["MSG_DASHBOARD_PLAN_USAGE_TITLE"] = "Usage";
translations["MSG_DASHBOARD_QUICK_SETTINGS_TITLE"] = "Quick Settings";
translations["MSG_DASHBOARD_SETTING_LANGUAGE"] = "Language";
translations["MSG_DASHBOARD_PLAN_USAGE_AI_CHAT"] = "AI Chat";
translations["MSG_DASHBOARD_PLAN_USAGE_AI_IMAGE"] = "AI Image";
translations["MSG_DASHBOARD_PLAN_USAGE_PROJECTS"] = "Projects";
translations["MSG_DASHBOARD_PLAN_USAGE_STORAGE"] = "Storage";

translations["MSG_TOP_TUTORIAL_FIRST_WELCOME_MESSAGE"] = "First time?\nWatch the\ntutorial!";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_1"] = "Let's do our best\ntogether today!";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_2"] = "Let's have fun learning\nwith puzzles!";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_3"] = "Learn\nprogramming\nwith me!";
translations["MSG_TOP_TUTORIAL_APP_START"] = "Start";
translations["MSG_TOP_TUTORIAL_START"] = "Watch Tutorial";
translations["MSG_TOP_TUTORIAL_DONOT_SHOW"] = "Don't show next time";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_1"] = "'Manande Puzzle'\nOverview";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_2"] = "About 'Learn with\nCourses'";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_3"] = "'Create Freely'\nOverview";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_4"] = "Help Button and\nMy Page";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_5"] = "About the Menu\nfor Parents";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_6"] = "Configure App\nSettings";
translations["MSG_TOP_TUTORIAL_CLOSE_PAGE"] = "Close this screen";
translations["MSG_TOP_TUTORIAL_NEXT_PAGE"] = "Next";
translations["MSG_TOP_TUTORIAL_START_APP"] = "Start 'Manande Puzzle'";
translations["MSG_ONBOARDING_PARENT_START"] = "Start the Puzzle";
translations["MSG_ONBOARDING_PARENT_START_SUB"] =
  "Parent registration required for new users\nTap here to log in and keep your data";
translations["MSG_ONBOARDING_SELF_START"] = "Try it out";
translations["MSG_ONBOARDING_SELF_START_SUB"] = "Try without registration";

// AuthSelection
translations["MSG_AUTH_SELECTION_INSTRUCTION"] =
  "Already have an account? Log in. New to Manande Puzzle? Sign up.";
translations["MSG_AUTH_SIGN_IN"] = "Log In";
translations["MSG_AUTH_SIGN_IN_DESC"] = "Sign in with existing account";
translations["MSG_AUTH_SIGN_UP"] = "Sign Up";
translations["MSG_AUTH_SIGN_UP_DESC"] = "Create a new account";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "Notification";

translations["MSG_TRIAL_NOTICE_TITLE"] = "Trial period is ending!";
translations["MSG_TRIAL_NOTICE_BODY"] = "Sign up as a parent to unlock more play and creation.";
translations["MSG_TRIAL_NOTICE_FOR_KIDS"] = "To continue, please register a parent.";
translations["MSG_TRIAL_NOTICE_NOTE_FREE"] = "Parent sign-up is free.";
translations["MSG_TRIAL_NOTICE_CTA"] = "Sign up as parent";
translations["MSG_PARENT_REGISTRATION_PROMPT_CTA_HINT"] =
  "To continue, please go to 「Parental controls」.";
translations["MSG_PARENT_REGISTRATION_PROMPT_CTA"] = "Parental controls";
translations["MSG_GUEST_PURCHASE_OVERLAY_HINT"] = "Please set up parental controls";

translations["MSG_BACK_BTN"] = "Back";
translations["MSG_HOME_BTN"] = "Home";
translations["MSG_CLOSE_BTN"] = "Close";
translations["MSG_CANCEL_BTN"] = "Cancel";
translations["MSG_CONFIRM_BTN"] = "Confirm";
translations["MSG_SAVE_BTN"] = "Save";
translations["MSG_STOP_BTN"] = "Stop";
translations["MSG_NEXT_BTN"] = "Next";
translations["MSG_GENERATE_BTN"] = "Generate";
translations["MSG_DELETE_BTN"] = "Delete";
translations["MSG_PARENTS_CANCEL_BTN"] = "Cancel";
translations["MSG_PARENTS_CONFIRM_BTN"] = "Confirm";
translations["MSG_PARENTS_DELETE_BTN"] = "Delete";
translations["MSG_ERROR_RELOAD_BTN"] = "Retry";
translations["MSG_ERROR_TITLE"] = "Could not complete the process correctly.";
translations["MSG_ERROR_MESSAGE"] =
  "Please try again.\nIf this screen appears again after retrying, please consult a parent.";
// Example US format

translations["MSG_TOAST_FAILED"] = "Failed";
translations["MSG_TOAST_SEND_FAILED"] = "Send failed";
translations["MSG_TOAST_EDIT_SUCCESS"] = "Changed successfully";
translations["MSG_TOAST_DELETED_SUCCESS"] = "Deleted successfully";
translations["MSG_TOAST_PUBLISHED_SUCCESS"] = "Published successfully";
translations["MSG_TOAST_DISABLE_PUBLISHED_SUCCESS"] = "Unpublished successfully";
translations["MSG_TOAST_ENABLE_COPIED_SUCCESS"] = "Copying allowed";
translations["MSG_TOAST_DISABLE_COPIED_SUCCESS"] = "Copying disallowed";
translations["MSG_TOAST_RESTORE_SUCCESS"] = "App restored";
translations["MSG_TOAST_COPY"] = "Copied.";
translations["MSG_TOAST_PAST"] = "Pasted.";
translations["MSG_TOAST_UNDO"] = "Undone.";
translations["MSG_TOAST_REDO"] = "Redone.";
translations["MSG_TOAST_INSERT_ASSET_IMAGE_SUCCESS"] = "Image added.";
translations["MSG_TOAST_INSERT_ASSET_TEMPLATE_SUCCESS"] = "Template added.";
translations["MSG_TOAST_CONTACT_SEND"] = "Inquiry sent.";
translations["MSG_SETTING_TOP_TUTORIAL"] = "App Startup Screen";
translations["MSG_SETTING_TOP_TUTORIAL_SHOW"] = "Show at start";
translations["MSG_SETTING_TOP_TUTORIAL_NOT_SHOW"] = "Do not show";
translations["MSG_SETTING_APP_LANGUAGE"] = "App Display Language";
translations["MSG_SETTING_SOUND"] = "Sound Effects";
translations["MSG_SETTING_BGM"] = "Music";
translations["MSG_SETTING_PARENT_GATE"] = "Parental Controls";
translations["MSG_SETTING_GO_TO_TOP"] = "Top Page";
translations["MSG_SETTING_GO_TO_CONTACT"] = "Contact Us";
translations["MSG_SETTING_GO_TO_REVIEW"] = "Rate App";
translations["MSG_SETTING_GO_TO_ASSISTANT"] = "Chat with Mana Pal";
translations["MSG_ASSISTANT_NAME"] = "Mana Pal";
translations["MSG_ASSISTANT_STATUS"] = "Ready to chat!";
translations["MSG_ASSISTANT_YOU"] = "You";
translations["MSG_ASSISTANT_PLACEHOLDER"] = "Type a message...";
translations["MSG_ASSISTANT_SEND"] = "Send";
translations["MSG_ASSISTANT_STOP"] = "Stop";
translations["MSG_ASSISTANT_GREETING"] =
  "Hello, %{name}!\nI'm Mana Pal.\nDo you have any questions?";
translations["MSG_ASSISTANT_USAGE_COUNT"] = "Today %{remaining}/%{limit}";
translations["MSG_ASSISTANT_EDUCATION_UNAVAILABLE"] =
  "Chatting with Mana Pal is not available with Education plan";
translations["MSG_ASSISTANT_PARENT_NOT_ALLOWED"] = "This feature is not allowed by your parent";
translations["MSG_ASSISTANT_SELECT_IMAGE"] = "Select a photo";
translations["MSG_ASSISTANT_TAB_ALBUM"] = "Album";
translations["MSG_ASSISTANT_TAB_DRAWING"] = "Drawing";
translations["MSG_ASSISTANT_TAB_AI"] = "AI Art";
translations["MSG_ASSISTANT_STAMP_TAB"] = "Sticker";
translations["MSG_ASSISTANT_LIMIT_REACHED"] = "That's all for today! See you tomorrow!";
translations["MSG_ASSISTANT_NEW_CHAT"] = "New Chat";
translations["MSG_ASSISTANT_UPGRADE_BTN"] = "More Chats";
translations["MSG_ASSISTANT_AI_ERROR"] =
  "I couldn't reply just now. Please wait a moment and try again!";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_TITLE"] = "Start Fresh!";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_MESSAGE"] =
  "Start the conversation over\nA different topic is totally OK\nYou can start anytime you want";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_BTN"] = "Start Chat";
translations["MSG_SETTING_CLOSE_BTN"] = "Close this screen";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "View Course Answers";
translations["MSG_SETTING_TITLE_CORPORATE_AUTH"] = "Corporate Authentication";
translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "Go to 'Manande Puzzle' site";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "Terms of Service";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "Privacy Policy";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "Contact Us";
// Example using count
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "Resume Play";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] = "Resume play for this player.";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "Suspend Play";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] = "Suspend play for this player.";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] = "Cannot Activate";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "The maximum number of active players is 4.\nTo activate this player, please deactivate (or delete) another unnecessary player.";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] = "Cannot Change";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "At least one player is required.\nCannot reduce the number of players further.";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_TITLE"] = "Cannot Change";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_MESSAGE"] =
  "Cannot suspend the currently logged-in player.\nPlease switch to another player before suspending this player.";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "Log Out";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "Logging out of the account will prevent you from playing with the current player.\nPlayer information is saved in the account, so if you want to play with the same player again, please log in again with this account.";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] = "【Important】Please Note";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "Deleting your account from 'Manande Puzzle' will delete all of the following data:\n・Registered profile and account information.\n・Registered player information for everyone.\n・Apps created by players in 'Create Freely'.\n・All grades and clear achievements for 'Learn with Courses' cleared by players.\n・'Talk History' etc. conducted by players.\n* 【Important】Deleting the logged-in account will delete all data related to this account, so please be very careful.\n* 【Important】This operation cannot be recovered under any circumstances. Please be very careful when deleting your account.";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] =
  "Please tell us the reason for deleting your account.";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] =
  "Are you sure you want to delete your account?";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "Deleting the account will remove all data including the account and players.\nAccount deletion cannot be recovered. Please be careful.";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"] = "Cannot Link";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"] =
  "Social account is already linked to another account.";
translations["MSG_SETTING_PARENTS_USER_KIDS_PROFILE_CREATED_AT"] = "Registration Date";
translations["MSG_SETTING_PARENTS_USER_PROFILE_LATEST_AT"] = "Last Login Date";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] = "Delete Account";
translations["MSG_SETTING_PARENTS_USER_PROFILE_DISPLAY_NAME_LIMIT"] =
  "Please enter within %{limit} characters.";

translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "Select Course";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "Select Stage";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "Select Level";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "Stage";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "Level";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] = "Authentication Code";

translations["MSG_CONTACT_TITLE"] = "Contact Us";
translations["MSG_CONTACT_TYPE_TITLE"] = "Select the type of inquiry";
translations["MSG_CONTACT_DETAIL_TITLE"] = "Please tell us the details";
translations["MSG_CONTACT_TYPE_HOW_TO"] = "Don't know\nhow to use";
translations["MSG_CONTACT_TYPE_BUG"] = "Doesn't work\nproperly";
translations["MSG_CONTACT_TYPE_REQUEST"] = "Feature\nrequest";
translations["MSG_CONTACT_TYPE_OTHER"] = "Other\nquestions";
translations["MSG_CONTACT_SEND_BTN"] = "Send Inquiry";

translations["MSG_PARENT_GATE_WARNING"] = "This page\nneeds an adult\nto check it\nfirst";
translations["MSG_PARENT_GATE_TITLE"] = "For Parents";
translations["MSG_PARENT_GATE_DESCRIPTION"] =
  "The following screen is the settings and account information page for parents.\nTo display the screen, please tap the images below in the indicated order and then press the proceed button.";
translations["MSG_PARENT_GATE_CLOSE_BTN"] = translations["MSG_SETTING_CLOSE_BTN"];
translations["MSG_PARENT_GATE_CONFIRM_BTN"] = "Proceed";
translations["MSG_PARENT_GATE_QUESTION_TITLE"] = "Tap the images in this order:";
translations["MSG_PARENT_GATE_LONGPRESS_INSTRUCTION"] = "Press and hold 「%{number}」.";
translations["MSG_PARENT_GATE_SHAPE_RECT"] = "Square";
translations["MSG_PARENT_GATE_SHAPE_STAR"] = "Star";
translations["MSG_PARENT_GATE_SHAPE_CIRCLE"] = "Circle";
translations["MSG_PARENT_GATE_SHAPE_TRIANGLE"] = "Triangle";
// MSG_PARENTS_PROFILE_DEFAULT_NAME is already defined above

translations["MSG_PARENT_REGISTRATION_MESSAGE_COURSE"] =
  "On the 「trial plan」 you can only play Stages 1 and 2 of Algorithm World.";
translations["MSG_PARENT_REGISTRATION_MESSAGE_PROJECT_LIMIT"] =
  "On the 「trial plan」 you can create up to %{limit} app(s).";
translations["MSG_PARENT_REGISTRATION_MESSAGE_CHILD_USER_LIMIT"] =
  "On the 「trial plan」 you can add up to %{limit} player(s).";
translations["MSG_PARENT_REGISTRATION_MESSAGE_AI_CHAT_LIMIT"] =
  "On the 「trial plan」 you can send up to %{limit} time(s) per day.";
translations["MSG_PARENT_REGISTRATION_MESSAGE_AI_IMAGE_LIMIT"] =
  "On the 「trial plan」 you can make up to %{limit} time(s) per day.";
translations["MSG_PARENT_REGISTRATION_MESSAGE_ASSET_LIMIT"] =
  "The 「trial plan」 allows up to 100 MB of assets.";

translations["MSG_COURSE_COMING_SOON_WARNING_MESSAGE"] =
  "This cassette can't be played yet.\nPlease wait a little longer!";
translations["MSG_COURSE_START_BTN"] = "Start";
translations["MSG_COURSE_GOTO_MAP_BTN"] = "Go to Map";
translations["MSG_COURSE_STAGE_CLEAR_TITLE"] = "Cleared up to here!";
translations["MSG_COURSE_LEVEL_OVERVIEW_SUMMARY"] = "What you'll learn in this level";
translations["MSG_COURSE_LEVEL_OVERVIEW_START_BTN"] = "Start";
translations["MSG_COURSE_GAME_TIPS_NEXT_BTN"] = "Next";
translations["MSG_COURSE_GAME_TIPS_BACK_BTN"] = "Back";
translations["MSG_COURSE_GAME_TIPS_ACTION_BTN"] = "Try it";
translations["MSG_COURSE_GAME_HINT_BTN"] = "Hint";
translations["MSG_COURSE_GAME_CLEAR"] = "Clear";
translations["MSG_COURSE_GAME_SCORE_TEXT"] = "Items obtained";
translations["MSG_COURSE_GAME_SCORE_STATUS"] = "/%{total}";
translations["MSG_COURSE_GAME_START_BTN"] = "Start!";
translations["MSG_COURSE_GAME_RESET_BTN"] = "Retry";
translations["MSG_COURSE_GAME_SUCCESS_TEXT"] = "Congratulations! You cleared this level!";
translations["MSG_COURSE_GAME_SUCCESS_REVIEW_BTN"] = "Review";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_LEVEL_BTN"] = "Next Level";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_STAGE_BTN"] = "Next Stage";
translations["MSG_COURSE_GAME_FAILED_TITLE"] = "Too bad!";
translations["MSG_COURSE_GAME_FAILED_TEXT"] =
  "Let's try again!\n\nIf it's too difficult, \nrefer to the hints.";
translations["MSG_COURSE_GAME_FAILED_RESET_BTN"] = "Try Again";
translations["MSG_COURSE_GAME_STAGE_CLEAR"] = "Congratulations! Stage cleared!";
translations["MSG_COURSE_ALL_GAME_STAGE_CLEAR"] =
  "Congratulations!\nYou've cleared all the stages\ncurrently available!\nLook forward to new stages\nbeing added!";
translations["MSG_COURSE_PROGRAM_RUN"] = "Run";
translations["MSG_COURSE_ALGORITHM"] = "Learn Algorithm!";
translations["MSG_COURSE_PROGRAM"] = "First Programming";
translations["MSG_COURSE_ALGORITHM_ADVANCED"] = "Algorithm Advanced";
translations["MSG_COURSE_SOKOBAN"] = "Sokoban Puzzle";
translations["MSG_COURSE_SOKOBAN_DESCRIPTION"] = "Push boxes and deliver them to the goal!";
translations["MSG_COURSE_SOKOBAN_LEVEL"] = "Level";
translations["MSG_COURSE_PIECE_BUILDER"] = "Piece Builder";
translations["MSG_BUILDER_TAB_MY_MAPS"] = "My Pieces";
translations["MSG_BUILDER_TAB_PUBLIC_MAPS"] = "Public Pieces";
translations["MSG_BUILDER_TAB_TRASH"] = "Trash";
translations["MSG_BUILDER_PUBLIC_COMING_SOON"] = "Coming soon!";
translations["MSG_BUILDER_DEMO_BUTTON"] = "DEMO";
translations["MSG_BUILDER_NEW_MAP_BTN"] = "New Piece";
translations["MSG_BUILDER_NEW_MAP_TITLE"] = "Create a new piece";
translations["MSG_BUILDER_MAP_DETAIL_BTN"] = "Details";
translations["MSG_BUILDER_MAP_EDIT_BTN"] = "Edit";
translations["MSG_BUILDER_MAP_RUN_BTN"] = "Run";
translations["MSG_BUILDER_MAP_COUNT"] = "%{count} pieces";
translations["MSG_BUILDER_FILTER_ALL"] = "All";
translations["MSG_BUILDER_FILTER_FAVORITE"] = "Favorite";
translations["MSG_BUILDER_FILTER_DRAFT"] = "Draft";
translations["MSG_BUILDER_FILTER_EDITING"] = "Editing";
translations["MSG_BUILDER_SORT_DESC"] = "Newest";
translations["MSG_BUILDER_SORT_ASC"] = "Oldest";
translations["MSG_BUILDER_SORT_POPULAR"] = "Popular";
translations["MSG_BUILDER_PUBLIC_COUNT"] = "%{count} pieces";
translations["MSG_BUILDER_PUBLIC_SEARCH_PLACEHOLDER"] = "Search by name or tag";
translations["MSG_BUILDER_PUBLIC_FILTER_OFFICIAL"] = "Official";
translations["MSG_BUILDER_PUBLIC_FILTER_COPIED"] = "Copied";
translations["MSG_BUILDER_PUBLIC_FILTER_TAG"] = "Tag";
translations["MSG_BUILDER_TRASH_COUNT"] = "%{count} in trash";
translations["MSG_BUILDER_TRASH_SORT"] = "By deleted date";
translations["MSG_BUILDER_TRASH_NOTICE"] = "Pieces disappear after 30 days";
translations["MSG_BUILDER_TRASH_DAYS_LEFT"] = "%{days} days left";
translations["MSG_BUILDER_CARD_STATUS_DRAFT"] = "Draft";
translations["MSG_BUILDER_CARD_STATUS_EDITING"] = "Editing";
translations["MSG_BUILDER_CARD_STATUS_UNPUBLISHED"] = "Unpublished";
translations["MSG_BUILDER_CARD_STATUS_PUBLISHED"] = "Published";
translations["MSG_BUILDER_CARD_STATUS_REMOVED"] = "Deleted";
translations["MSG_BUILDER_CARD_STATUS_OFFICIAL"] = "Official";
translations["MSG_BUILDER_CARD_BADGE_REMIX"] = "Remix";
translations["MSG_BUILDER_CARD_REMIX_FROM"] = "Original: %{name}";
translations["MSG_BUILDER_BTN_PLAY"] = "Play";
translations["MSG_BUILDER_BTN_CONTINUE"] = "Continue";
translations["MSG_BUILDER_BTN_PUBLISHED_NOW"] = "Play published";
translations["MSG_BUILDER_BTN_RESUME"] = "Resume";
translations["MSG_BUILDER_BTN_RESTORE"] = "Restore";
translations["MSG_BUILDER_BTN_DELETE_FOREVER"] = "Delete";
translations["MSG_BUILDER_BTN_COPY"] = "Copy";
translations["MSG_BUILDER_MENU_HINT"] = "Write hints";
translations["MSG_BUILDER_MENU_COPY"] = "Copy & create";
translations["MSG_BUILDER_MENU_TO_TRASH"] = "Move to trash";
translations["MSG_BUILDER_MENU_LIKE"] = "Like";
translations["MSG_BUILDER_MENU_REACTION"] = "Reaction";
translations["MSG_BUILDER_MENU_REPORT"] = "Report";
translations["MSG_BUILDER_TO_TRASH_CONFIRM_TITLE"] = "Move to trash?";
translations["MSG_BUILDER_TO_TRASH_CONFIRM_MSG"] =
  'Move "%{name}" to trash. You can restore it later.';
translations["MSG_BUILDER_TO_TRASH_TOAST"] = "Moved to trash";
translations["MSG_BUILDER_TRASH_RESTORE_TOAST"] = "Restored";
translations["MSG_BUILDER_TRASH_DELETE_CONFIRM_TITLE"] = "Delete forever?";
translations["MSG_BUILDER_TRASH_DELETE_CONFIRM_MSG"] =
  'Permanently delete "%{name}". This cannot be undone.';
translations["MSG_BUILDER_TRASH_DELETE_TOAST"] = "Deleted";
translations["MSG_BUILDER_LIKE_TOAST"] = "Liked!";
translations["MSG_BUILDER_COPY_TOAST"] = "Copied!";
translations["MSG_BUILDER_DETAIL_TAB_RANKING"] = "Ranking";
translations["MSG_BUILDER_DETAIL_AUTHOR_BY"] = "Made by %{name}";
translations["MSG_BUILDER_DETAIL_APP_CODE"] = "App code";
translations["MSG_BUILDER_DETAIL_PUBLISHED_AT"] = "Published";
translations["MSG_BUILDER_DETAIL_UPDATED_AT"] = "Updated";
translations["MSG_BUILDER_DETAIL_RANKING_MOVES"] = "Fewest moves";
translations["MSG_BUILDER_DETAIL_RANKING_TIME"] = "Fastest time";
translations["MSG_BUILDER_DETAIL_RANKING_WORLD"] = "World record";
translations["MSG_BUILDER_DETAIL_RANKING_MOVES_UNIT"] = "%{n} moves";
translations["MSG_BUILDER_DETAIL_RANKING_YOU"] = "You";
translations["MSG_BUILDER_DETAIL_HINT_TITLE"] = "Write hints";
translations["MSG_BUILDER_DETAIL_HINT_DESC"] = "If empty, hints are made automatically";
translations["MSG_BUILDER_DETAIL_HINT_LV1"] = "① Easy";
translations["MSG_BUILDER_DETAIL_HINT_LV2"] = "② Normal";
translations["MSG_BUILDER_DETAIL_HINT_LV3"] = "③ Answer";
translations["MSG_BUILDER_DETAIL_HINT_PLACEHOLDER"] = "Write a hint";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_TITLE"] = "How to Play";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_DESC"] = "Push all the boxes onto the goals!";
translations["MSG_SOKOBAN_TUTORIAL_CONTROLLER_TITLE"] = "Controls";
translations["MSG_SOKOBAN_TUTORIAL_CONTROLLER_DESC"] =
  "Use the buttons in the bottom-right to move your character.";
translations["MSG_SOKOBAN_TUTORIAL_CAMERA_TITLE"] = "Camera";
translations["MSG_SOKOBAN_TUTORIAL_CAMERA_DESC"] =
  "Drag the circle in the bottom-left to rotate the camera.";
translations["MSG_SOKOBAN_TUTORIAL_BTN_FORWARD"] = "Forward";
translations["MSG_SOKOBAN_TUTORIAL_BTN_TURN_LEFT"] = "Turn Left";
translations["MSG_SOKOBAN_TUTORIAL_BTN_TURN_RIGHT"] = "Turn Right";
translations["MSG_SOKOBAN_TUTORIAL_BTN_JUMP"] = "Jump";
translations["MSG_SOKOBAN_TUTORIAL_NEXT_BTN"] = "Next";
translations["MSG_SOKOBAN_TUTORIAL_START_BTN"] = "Start!";
translations["MSG_SOKOBAN_TUTORIAL_TITLE"] = "Tutorial";
translations["MSG_SOKOBAN_TUTORIAL_TAP_TO_CONTINUE"] = "Tap to continue";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_HINT"] = "Aim here!";
translations["MSG_COURSE_GROUP_WORK"] = "Group Work";
translations["MSG_COURSE_COORDINATE_X"] = "Horizontal Position (X Coordinate)";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_NEXT_BTN"] = "Next";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CONTINUE_BTN"] = "Continue Guide";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_ACTION_BTN"] = "Try it";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CLOSE_BTN"] = "End Guide";
translations["MSG_CREATOR_CREATE_APP"] = "Create App";
translations["MSG_CREATOR_CREATE_APP_TITLE"] = "Create App";
translations["MSG_CREATOR_CREATE_APP_NAME"] = "Please name the app.";
translations["MSG_CREATOR_CREATE_APP_NAME_PREFIX"] = "App";
translations["MSG_CREATOR_APP_DETAIL_BTN"] = "Details";
translations["MSG_CREATOR_RUN_APP_BTN"] = "Run";
translations["MSG_CREATOR_APP_MY_APPS"] = "My Apps";
translations["MSG_CREATOR_APP_SHARED_APPS"] = "Shared Apps";
translations["MSG_CREATOR_APP_SHARED_APPS_EMPTY_MESSAGE"] =
  "No apps found matching these criteria.\nPlease change the criteria and search again.";
translations["MSG_CREATOR_APP_DELETED_APPS"] = "Trash";
translations["MSG_CREATOR_APP_DELETED_APPS_MESSAGE"] =
  "Select the app you want to return\nto 'My Apps'.\n(Up to 5 recently deleted\napps are kept)";
translations["MSG_CREATOR_APP_SETTING_TITLE"] = "App Settings";
translations["MSG_CREATOR_APP_SETTING_APP_NAME"] = "App Name";
translations["MSG_CREATOR_APP_SETTING_APP_TAG"] = "Tag";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_TITLE"] = "Publish to Shared Apps";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_OFF"] = "Private";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_ON"] = "Public";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_TITLE"] = "Allow others to copy";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_OFF"] = "Disallow\nCopying";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_ON"] = "Allow\nCopying";
translations["MSG_CREATOR_APP_SETTING_APP_CHANGE_COVER_PAGE_BTN"] = "Change Cover Page";
translations["MSG_CREATOR_APP_DETAIL_APP_AUTHOR"] = "Original Creator";
translations["MSG_CREATOR_APP_DETAIL_APP_EDITOR"] = "Last Editor";
translations["MSG_CREATOR_APP_NAME_PLACEHOLDER"] = "Enter name";
translations["MSG_CREATOR_APP_SELECT_PLACEHOLDER"] = "select app";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_TITLE"] = "App Description";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_NONE"] = "No description";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_PLACEHOLDER"] = "Enter app description";
translations["MSG_CREATOR_APP_DETAIL_TITLE_APP_CODE"] = "App\nCode";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP"] = "Shared\nApp";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_PUBLISHED"] = "Public";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_NOT_PUBLISHED"] = "Private";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS"] = "Other\nusers";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_ENABLE"] = "Can copy";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_DISABLE"] = "Cannot copy";
translations["MSG_CREATOR_APP_DETAIL_APP_DELETED_AT"] = "Deletion\nDate";
translations["MSG_CREATOR_APP_EDITOR_BTN"] = "Create";
translations["MSG_CREATOR_APP_COMPLETELY_BTN"] = "Delete Permanently";
translations["MSG_CREATOR_APP_RESTORE_BTN"] = "Restore";
translations["MSG_CREATOR_APP_DELETE_WARNING_TITLE"] = "Delete app?";
translations["MSG_CREATOR_APP_DELETE_WARNING_MESSAGE"] =
  'Delete "%{name}"?\nYou will not be able to edit the app.\nYou will not be able to use the app.';
translations["MSG_CREATOR_ASSET_DELETE_WARNING_TITLE"] = "Delete image?";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_MESSAGE"] =
  'Delete "%{name}"?\nOnce deleted, the image cannot be recovered.';
translations["MSG_CREATOR_CREATE_APP_PICKUP_NAME"] = "Pickup";
translations["MSG_CREATOR_CREATE_APP_PICKUP_MONTH_TITLE"] = "%{month}'s"; // e.g., "August's"
translations["MSG_CREATOR_CREATE_APP_PICKUP_SUBTITLE"] = "Introducing interesting apps!";
translations["MSG_CREATOR_APP_PUBLISH_TITLE"] = "Publish to 'Shared Apps'?";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_TITLE"] = "Cannot publish app";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_MESSAGE"] =
  "App publishing is not allowed.\nPlease allow it from the parent menu.";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_TITLE"] = "Stop publishing to 'Shared Apps'?";
translations["MSG_CREATOR_APP_PUBLISH_WARNING"] =
  "Publish \"%{name}\" to 'Shared Apps'.\nPublishing the app allows others to use it.";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_WARNING"] =
  "Stop publishing \"%{name}\" to 'Shared Apps'.\nStopping publication prevents others from using the app.";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_ENABLE"] = "Publish & Allow Copy";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_DISABLE"] = "Publish & Disallow Copy";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_NOTICE"] = "* You can unpublish the app later.";
translations["MSG_CREATOR_PUBLISH_CONFIRM_BTN"] = "Publish";
translations["MSG_CREATOR_DISABLE_PUBLISH_CONFIRM_BTN"] = "Make Private";
translations["MSG_CREATOR_APP_ENABLE_COPIED_TITLE"] = "Copy Setting for This App";
translations["MSG_CREATOR_APP_DISABLE_COPIED_TITLE"] = "Copy Setting for This App";
translations["MSG_CREATOR_APP_ENABLE_COPIED_MESSAGE"] = 'Allow others to copy "%{name}".';
translations["MSG_CREATOR_APP_DISABLE_COPIED_MESSAGE"] = 'Disallow others from copying "%{name}".';
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_TITLE"] = "This image cannot be used";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_MESSAGE"] =
  "Only the latest %{limit} images can be added to the app.\nWe will notify you when other images become available.";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_TITLE"] = "Cannot delete app";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_MESSAGE"] =
  "Apps published to Shared Apps cannot be deleted.\nIf you want to delete this app, please make it private first.\n";
// Plan-based project limit messages
// Trial user (account creation promotion)
// Plan-based tutorial limit messages
// Trial user
// Free user
// Standard plan user
translations["MSG_CREATOR_APP_SORT_FILTER_TITLE"] = "Find";
translations["MSG_CREATOR_APP_KEYWORD_SEARCH_TITLE"] = "Find by Keyword";
translations["MSG_CREATOR_APP_SORT_TITLE"] = "Sort";
translations["MSG_CREATOR_APP_SORT_FAVORITED"] = "Popularity";
translations["MSG_CREATOR_APP_SORT_VIEWED"] = "Popularity";
translations["MSG_CREATOR_APP_SORT_DATE"] = "Time";
translations["MSG_CREATOR_APP_FILTER_TITLE"] = "Filter";
translations["MSG_CREATOR_APP_FILTER_OFFICIAL"] = "Official";
translations["MSG_CREATOR_APP_FILTER_FAVORITED"] = "Liked";
translations["MSG_CREATOR_APP_DISABLE_BTN"] = "Cannot";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_TITLE"] = "Permanently delete app?";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_SUBTITLE"] =
  'Permanently delete "%{name}"?\nOnce permanently deleted, the app cannot be recovered.';
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_TITLE"] = "Restore to 'My Apps'?";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_SUBTITLE"] = "Restore \"%{name}\" to 'My Apps'?";
translations["MSG_CREATOR_SCREEN_LIST_HEADER"] = "Pages";
translations["MSG_CREATOR_COMPONENT_LIST_HEADER"] = "Selected";
translations["MSG_CREATOR_MENU_CONTEXT_DELETE"] = "Delete";
translations["MSG_CREATOR_MENU_CONTEXT_COPY"] = "Copy";
translations["MSG_CREATOR_MENU_CASSETTE_ACTION"] = "Cassette Actions";
translations["MSG_CREATOR_MENU_RUN_APP_BTN"] = "Run\nApp";
translations["MSG_CREATOR_MENU_SET_APP_BTN"] = "App\nSettings";
translations["MSG_CREATOR_MENU_PUBLISH_APP_BTN"] = "Publish\nApp";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_APP_BTN"] = "Unpublish\nApp";
translations["MSG_CREATOR_MENU_PUBLISH_TEMPLATE_BTN"] = "Publish\nTemplate";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_TEMPLATE_BTN"] = "Unpublish\nTemplate";
translations["MSG_CREATOR_MENU_CLOSE_BTN"] = "Close\nThis Screen";
translations["MSG_CREATOR_MENU_COMPONENT_BTN"] = "Parts";
translations["MSG_CREATOR_MENU_COMPONENT_ACTION_BTN"] = "Actions";
translations["MSG_CREATOR_MENU_COMPONENT_SHAPE_BTN"] = "Shapes";
translations["MSG_CREATOR_MENU_COMPONENT_STAMP_BTN"] = "Stamps";
translations["MSG_CREATOR_MENU_COMPONENT_STOCK_BTN"] = "Toolbox";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_ACTION"] = "Action Parts";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_SHAPE"] = "Shape Parts";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP"] = "Stamp Parts";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_CHARACTER"] = "Characters";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GAME"] = "Activities/Play";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ANIMAL"] = "Animals";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_EVENT"] = "Events";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_INTERNET"] = "Internet";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_MONEY"] = "Economy/Money";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GOODS"] = "Daily Goods";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_NATURE"] = "Nature/Plants";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_PERSON"] = "People";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_BUILDING"] = "Buildings";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_FOOD"] = "Food";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ELECTRONIC"] = "Electronics/Communication";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_SMILE"] = "Smiley";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_VEHICLE"] = "Vehicles";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_STATIONARY"] = "Stationery";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_OTHERS"] = "Others";
translations["MSG_CREATOR_MENU_DRAWING_BTN"] = "Drawing";
translations["MSG_CREATOR_MENU_DRAWING_PEN"] = "Pen";
translations["MSG_CREATOR_MENU_DRAWING_ERASER"] = "Eraser";
translations["MSG_CREATOR_MENU_DRAWING_SIZE"] = "Thickness";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_LIGHT"] = "Thin";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_NORMAL"] = "Normal";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_BOLD"] = "Thick";
translations["MSG_CREATOR_MENU_DRAWING_COLOR"] = "Color";
translations["MSG_CREATOR_MENU_DRAWING_RESET"] = "Reset";
translations["MSG_CREATOR_MENU_DRAWING_FINISH"] = "Finish";
translations["MSG_CREATOR_MENU_STOCK_PARTS_USE_BTN"] = "Add";
translations["MSG_CREATOR_MENU_COMPONENT_PREVIEW_TITLE"] = "%{name} Part List";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"] = "Album";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"] = "Sketchbook";
translations["MSG_CREATOR_MENU_PROPERTY_BTN"] = "Design";
translations["MSG_CREATOR_MENU_PROPERTY_BASIC"] = "Basic";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION"] = "Position";
translations["MSG_CREATOR_MENU_PROPERTY_SIZE"] = "Size";
translations["MSG_CREATOR_MENU_PROPERTY_APPEARANCE"] = "Appearance";
translations["MSG_CREATOR_MENU_PROPERTY_COLOR"] = "Color";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC"] = "Program";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC_TITLE"] = "%{name}'s Program";

translations["MSG_CREATOR_MENU_PROPERTY_NAME"] = "Name";
translations["MSG_CREATOR_MENU_PROPERTY_NAME_PLACEHOLDER"] = "Enter name";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE_TITLE"] = "Top Page";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE"] = "Start from this page";
translations["MSG_CREATOR_MENU_PROPERTY_FONT_FAMILY"] = "Font Type";
translations["MSG_CREATOR_TEXT_WEIGHT_BOLD"] = "Bold";
translations["MSG_CREATOR_TEXT_WEIGHT_REGULAR"] = "Regular";
translations["MSG_CREATOR_TEXT_WEIGHT_LIGHT"] = "Light";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT"] = "Display Content";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX"] = "Layer";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_FRONT"] = "Bring to Front";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_BACK"] = "Send to Back";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION_X_Y"] = "Horizontal and Vertical Position";
translations["MSG_CREATOR_MENU_PROPERTY_X"] = "Horizontal Position";
translations["MSG_CREATOR_MENU_PROPERTY_Y"] = "Vertical Position";
translations["MSG_CREATOR_MENU_PROPERTY_X_COORDINATE"] = "X";
translations["MSG_CREATOR_MENU_PROPERTY_Y_COORDINATE"] = "Y";
translations["MSG_CREATOR_MENU_PROPERTY_WIDTH"] = "Width";
translations["MSG_CREATOR_MENU_PROPERTY_HEIGHT"] = "Height";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER"] = "Border";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW"] = "Shadow";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SIZE"] = "Text";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW"] = "Text Shadow";
translations["MSG_CREATOR_MENU_PROPERTY_OPACITY"] = "Opacity";
translations["MSG_CREATOR_MENU_PROPERTY_ROTATION"] = "Angle";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_RADIUS"] = "Corner Radius";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO"] = "Image Information";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_NAME"] = "Name";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_SIZE"] = "Size";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_FILE_SIZE"] = "File Size";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_BTN"] = "Select Image";
translations["MSG_CREATOR_MENU_PROPERTY_BACKGROUND_COLOR"] = "Fill";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_COLOR"] = "Border";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW_COLOR"] = "Shadow";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_COLOR"] = "Text";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW_COLOR"] = "Text Shadow";

translations["MSG_CREATOR_MENU_BLOCKLY_TITLE"] = "Blocks";
translations["MSG_CREATOR_MENU_BLOCKLY_EVENT"] = "Events";
translations["MSG_CREATOR_MENU_BLOCKLY_ANIMATION"] = "Motion";
translations["MSG_CREATOR_MENU_BLOCKLY_CONTROL"] = "Control";
translations["MSG_CREATOR_MENU_BLOCKLY_LOGIC"] = "Logic";
translations["MSG_CREATOR_MENU_BLOCKLY_MATH"] = "Math";
translations["MSG_CREATOR_MENU_BLOCKLY_VARIABLE"] = "Variables";
translations["MSG_CREATOR_MENU_BLOCKLY_PROCEDURE"] = "Functions";
translations["MSG_CREATOR_MENU_BLOCKLY_PROMPT_INPUT_MESSAGE"] = "Value for %{placeholder}";

translations["MSG_CREATOR_COMPONENT_NAME_SCREEN"] = "Page";
translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"] = "Button";
translations["MSG_CREATOR_COMPONENT_NAME_LABEL"] = "Label";
translations["MSG_CREATOR_COMPONENT_NAME_FORM"] = "Form";
translations["MSG_CREATOR_COMPONENT_NAME_CHECKBOX"] = "Checkbox";
translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"] = "Switch";
translations["MSG_CREATOR_COMPONENT_NAME_IMAGE"] = "Image";
translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"] = "Circle";
translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"] = "Triangle";
translations["MSG_CREATOR_COMPONENT_NAME_RECT"] = "Rectangle";
translations["MSG_CREATOR_COMPONENT_NAME_STAR"] = "Star";
translations["MSG_CREATOR_COMPONENT_NAME_LINE"] = "Line";
translations["MSG_CREATOR_COMPONENT_NAME_STAMP"] = "Stamp";
translations["MSG_CREATOR_COMPONENT_NAME_DRAWING"] = "Drawing";
translations["MSG_CREATOR_COMPONENT_LABEL_BUTTON"] =
  translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"];
translations["MSG_CREATOR_COMPONENT_LABEL_LABEL"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LABEL"];
translations["MSG_CREATOR_COMPONENT_LABEL_FORM"] = translations["MSG_CREATOR_COMPONENT_NAME_FORM"];
translations["MSG_CREATOR_COMPONENT_LABEL_CHECKBOX"] = "Check\nbox";
translations["MSG_CREATOR_COMPONENT_LABEL_SWITCH"] =
  translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"];
translations["MSG_CREATOR_COMPONENT_LABEL_IMAGE"] = "Image\nBox";
translations["MSG_CREATOR_COMPONENT_LABEL_CIRCLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_TRIANGLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_RECT"] = "Square"; // Changed from 四角 (Shikaku) to Square for better fit
translations["MSG_CREATOR_COMPONENT_LABEL_STAR"] = translations["MSG_CREATOR_COMPONENT_NAME_STAR"];
translations["MSG_CREATOR_COMPONENT_LABEL_LINE"] = translations["MSG_CREATOR_COMPONENT_NAME_LINE"];

translations["MSG_BLOCKLY_VARIABLES"] = "Variables";
translations["MSG_BLOCKLY_INPUT_NUMBER_LIMIT"] = "Please enter a number.";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] = "Please enter within %{limit} characters.";
translations["MSG_ASSET_ALBUM_TITLE"] = "Album Contents";
translations["MSG_ASSET_DRAWING_TITLE"] = "Sketchbook Contents";
translations["MSG_ASSET_ALBUM_ADD_TITLE"] = "Add Image";
translations["MSG_ASSET_DRAWING_ADD_ALBUM_TITLE"] =
  "Images and photos added in 'Manande Puzzle' will be added here.";
translations["MSG_ASSET_DRAWING_ADD_WARNING_TITLE"] =
  "Drawings made in the 'Drawing' menu of 'Create Freely' will be added here.";
translations["MSG_ASSET_ADD_TO_SCREEN_BTN"] = "Add to\nApp";
translations["MSG_CREATOR_MENU_MATERIAL_TAB_ASSET_SELECT"] = "Add to\nChat";
translations["MSG_ASSET_DELETE_BTN"] = "Delete\nImage";
translations["MSG_ASSET_ALBUM_EMPTY_MESSAGE"] = "No image data yet.";
translations["MSG_ASSET_DRAWING_EMPTY_MESSAGE"] = "No drawing data yet.";
translations["MSG_ASSET_STORAGE_OVER_LIMIT"] = "Storage is full";
translations["MSG_REACTION_TAG_TITLE"] = "Feeling Stamps";
translations["MSG_REACTION_USERS"] = "Everyone's\nFeelings";
translations["MSG_REACTION_DIFFICULT"] = "Tough!";
translations["MSG_REACTION_EASY"] = "Easy";
translations["MSG_REACTION_COOL"] = "Cool!";
translations["MSG_REACTION_FUN"] = "Fun";
translations["MSG_REACTION_AMAZING"] = "Amazing";
translations["MSG_REACTION_BAD"] = "Hmm?";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_LATER_BTN"] = "See later";

// User Plan
translations["MSG_CURRENT_PLAN"] = "Current Plan";
translations["MSG_PLAN_TRIAL"] = "Trial";
translations["MSG_PLAN_SAKIDORI"] = "Early Access";
translations["MSG_PLAN_FREE"] = "Free";
translations["MSG_PLAN_STANDARD"] = "Standard";
translations["MSG_PLAN_PREMIUM"] = "Premium";
translations["MSG_PLAN_BUILDER"] = "Builder";
translations["MSG_PLAN_EDUCATION"] = "Classroom";
translations["MSG_PLAN_UNKNOWN"] = "Unknown";
translations["MSG_PLAN_FREE_FULL"] = "Free Plan";
translations["MSG_PLAN_STANDARD_FULL"] = "Standard Plan";
translations["MSG_PLAN_PREMIUM_FULL"] = "Premium Plan";
// Plan names for parent pages
translations["MSG_PLAN_TRIAL_PARENT"] = "Trial";
translations["MSG_PLAN_FREE_PARENT"] = "Free";
translations["MSG_PLAN_STANDARD_PARENT"] = "Standard";
translations["MSG_PLAN_PREMIUM_PARENT"] = "Premium";
translations["MSG_PLAN_BUILDER_PARENT"] = "Builder";
translations["MSG_PLAN_EDUCATION_PARENT"] = "Education";
translations["MSG_PLAN_UNKNOWN_PARENT"] = "Unknown";
translations["MSG_PLAN_FREE_FULL_PARENT"] = "Free Plan";
translations["MSG_PLAN_STANDARD_FULL_PARENT"] = "Standard Plan";
translations["MSG_PLAN_PREMIUM_FULL_PARENT"] = "Premium Plan";

// Subscription - Common
translations["MSG_BACK_BTN"] = "Back";
// Subscription - Purchase Page
translations["MSG_SUBSCRIPTION_MONTHLY_TITLE"] = "Monthly Plan";
translations["MSG_SUBSCRIPTION_ANNUAL_TITLE"] = "Annual Plan";
translations["MSG_SUBSCRIPTION_ANNUAL_BADGE"] = "Save 2 months!";
translations["MSG_SUBSCRIPTION_PURCHASE_BTN"] = "Purchase";
translations["MSG_SUBSCRIPTION_UPGRADE_BTN"] = "Upgrade";
translations["MSG_SUBSCRIPTION_PURCHASE_SUCCESS"] = "Purchase completed!";
translations["MSG_SUBSCRIPTION_PURCHASE_ERROR"] = "Purchase failed. Please try again.";
// Subscription - Status Page
translations["MSG_SUBSCRIPTION_REACTIVATE_SUCCESS"] = "Subscription reactivated";
translations["MSG_SUBSCRIPTION_REACTIVATE_ERROR"] = "Failed to reactivate subscription";
translations["MSG_SUBSCRIPTION_PORTAL_ERROR"] = "Failed to open portal";

// Subscription - Cancel Page
translations["MSG_SUBSCRIPTION_CANCEL_CONFIRM_TITLE"] = "Are you sure you want to cancel?";
translations["MSG_SUBSCRIPTION_CANCEL_CONFIRM_MESSAGE"] =
  "Your subscription will be cancelled and you'll return to the free plan on your next billing date.\nYour data will be preserved.";
translations["MSG_SUBSCRIPTION_CANCEL_SUCCESS"] = "Cancellation accepted";
translations["MSG_SUBSCRIPTION_CANCEL_ERROR"] = "Cancellation failed";
// Refund (Cooling-off period)
// Stripe Elements Payment Modal
// Parent Page - Tabs
translations["MSG_PARENT_PAGE_TAB_ACCOUNT"] = "Parent Account";
translations["MSG_PARENT_PAGE_TAB_PLAYER"] = "Player";
translations["MSG_PARENT_PAGE_TAB_SUBSCRIPTION"] = "Billing";
translations["MSG_PARENT_PAGE_TAB_NOTIFICATION"] = "Notifications";
translations["MSG_PARENT_PAGE_TAB_MESSAGE"] = "Messages";
translations["MSG_PARENT_PAGE_TAB_OTHER"] = "Other";

// Parent Page - Message Tab
translations["MSG_PARENT_PAGE_MESSAGE_INPUT_PLACEHOLDER"] = "Type a message...";
translations["MSG_PARENT_PAGE_MESSAGE_NO_ROOMS"] = "No chat rooms available";
translations["MSG_PARENT_PAGE_MESSAGE_NO_MESSAGES"] = "No messages yet";
translations["MSG_PARENT_PAGE_MESSAGE_LOAD_MORE"] = "Load more";
translations["MSG_LOADING"] = "Loading...";

// Parent Page - Plan Names
translations["MSG_PARENT_PAGE_SUBSCRIPTION_SOURCE"] = "Purchase Method";
translations["MSG_PARENT_PAGE_EDUCATION_DESCRIPTION"] =
  "You are on a corporate contract. Please contact your administrator for details.";

// Parent Page - Account Tab
translations["MSG_PARENT_PAGE_ACCOUNT_INFO"] = "Account Information";
translations["MSG_PARENT_PAGE_NICKNAME"] = "Nickname";
translations["MSG_PARENT_PAGE_ICON"] = "Icon";
translations["MSG_PARENT_PAGE_EMAIL"] = "Email";
translations["MSG_PARENT_PAGE_EMAIL_VERIFIED"] = "Email Verification";
translations["MSG_PARENT_PAGE_VERIFIED"] = "Verified";
translations["MSG_PARENT_PAGE_CREATED_AT"] = "Account Created";
translations["MSG_PARENT_PAGE_CHANGE"] = "Change";
translations["MSG_PARENT_PAGE_SNS_LINK"] = "Account Linking";
translations["MSG_PARENT_PAGE_GOOGLE_ACCOUNT"] = "Google Account";
translations["MSG_PARENT_PAGE_APPLE_ID"] = "Apple ID";
translations["MSG_PARENT_PAGE_LINK"] = "Link";
translations["MSG_PARENT_PAGE_UNLINK"] = "Unlink";

// Parent Page - Profile Section
translations["MSG_PARENT_PAGE_PROFILE_SECTION_TITLE"] = "Profile Information";
translations["MSG_PARENT_PAGE_PROFILE_EDIT_TITLE"] = "Edit Profile";
translations["MSG_PARENT_PAGE_PROFILE_NOT_SET"] = "Not set";
translations["MSG_PARENT_PAGE_PROFILE_BASIC_INFO"] = "Basic Information";
translations["MSG_PARENT_PAGE_PROFILE_REGION_PLACEHOLDER"] = "e.g. California";
translations["MSG_PARENT_PAGE_PROFILE_CITY_PLACEHOLDER"] = "e.g. Los Angeles";
translations["MSG_PARENT_PAGE_PROFILE_NOTES"] = "Additional Notes";
translations["MSG_PARENT_PAGE_TAB_BASIC"] = "Basic Info";
translations["MSG_PARENT_PAGE_TAB_FAVORITES"] = "Personality";
translations["MSG_PARENT_PAGE_TAB_APPEARANCE"] = "Avatar";
translations["MSG_PARENT_PAGE_NOT_SET"] = "Not set";
translations["MSG_PARENT_PAGE_EDIT_FAVORITE_COLOR"] = "Edit Favorite Colors";
translations["MSG_PARENT_PAGE_EDIT_SELF_INTRO"] = "Edit Self Introduction";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_SUCCESS"] = "Profile updated successfully";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_ERROR"] = "Failed to update profile";

// Parent Page - Icon Edit Modal
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT"] = "Current";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED"] = "Use this one?";
translations["MSG_ICON_CHANGE_CONFIRM_BTN"] = "Confirm";
translations["MSG_ICON_CHANGE_AI_CANCEL"] = "Cancel";
// AI Usage Limits
translations["MSG_QUOTA_EXCEEDED"] = "You've used all for today! Try again tomorrow!";
translations["MSG_QUOTA_RESET_TIME"] = "Resets at midnight";
translations["MSG_AI_PROCESSING"] = "AI is generating...";

translations["MSG_PARENT_PAGE_ACCOUNT_ACTIONS"] = "Account Actions";
translations["MSG_PARENT_PAGE_CHANGE_PASSWORD"] = "Change Password";
translations["MSG_PARENT_PAGE_LOGOUT"] = "Logout";
// Parent Page - Nickname Edit Modal
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_TITLE"] = "Change Nickname";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_MESSAGE"] = "Please enter your new nickname";
translations["MSG_PARENT_PAGE_NICKNAME_ERROR_MESSAGE"] = "Please try a different name";
// Parent Page - Child Management Tab
translations["MSG_PARENT_PAGE_ADD"] = "Add";
translations["MSG_PARENT_PAGE_ACTIVE"] = "Active";
translations["MSG_PARENT_PAGE_INACTIVE"] = "Inactive";
translations["MSG_PARENT_PAGE_PLAYABLE"] = "Playable";
translations["MSG_PARENT_PAGE_SUSPENDED"] = "Suspended";
translations["MSG_PARENT_PAGE_SWITCH_LOGIN"] = "Switch";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_TITLE"] = "Cannot Switch";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_MESSAGE"] =
  "This player is frozen and cannot be switched to. Please activate the player first.";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_TITLE"] = "Switch Player?";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_MESSAGE"] = 'Switch to "%{name}".';
translations["MSG_PARENT_PAGE_BASIC_INFO"] = "Basic Info";
translations["MSG_PARENT_PAGE_AGE"] = "Age";
translations["MSG_PARENT_PAGE_YEARS_OLD"] = " years old";
translations["MSG_PARENT_PAGE_GENDER"] = "Gender";
translations["MSG_PARENT_PAGE_BIRTHDAY"] = "Birthday";
translations["MSG_PARENT_PAGE_ACCOUNT_CREATED_DATE"] = "Account Created";
translations["MSG_GENDER_SELECT_TITLE"] = "Choose one";
translations["MSG_GENDER_STATUS_LABEL"] = "Gender";
translations["MSG_GENDER_NOT_SELECTED"] = "Not selected";
translations["MSG_GENDER_MALE"] = "Boy";
translations["MSG_GENDER_FEMALE"] = "Girl";
translations["MSG_GENDER_NONE"] = "None";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_TITLE"] = "Change Name";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_MESSAGE"] = "Enter a new name";
translations["MSG_PARENT_PAGE_YEAR"] = "Year";
translations["MSG_PARENT_PAGE_MONTH"] = "Month";
translations["MSG_PARENT_PAGE_DAY"] = "Day";
translations["MSG_PARENT_PAGE_GENDER_EDIT_TITLE"] = "Change Gender";
translations["MSG_PARENT_PAGE_GENDER_EDIT_MESSAGE"] = "Select gender";
translations["MSG_PARENT_PAGE_BIRTHDAY_EDIT_TITLE"] = "Change Birthday";
translations["MSG_PARENT_PAGE_COURSE_CLEAR"] = "Courses Completed";
translations["MSG_PARENT_PAGE_CREATED_PROJECTS"] = "Projects Created";
translations["MSG_PARENT_PAGE_PUBLISHED_PROJECTS"] = "Published Projects";
translations["MSG_PARENT_PAGE_RECEIVED_LIKES"] = "Likes Received";
translations["MSG_PARENT_PAGE_SETTINGS"] = "Settings";
translations["MSG_PARENT_PAGE_DISPLAY_LANGUAGE"] = "Language";
translations["MSG_PARENT_PAGE_HIRAGANA"] = "Hiragana";
translations["MSG_PARENT_PAGE_KANJI"] = "Kanji";
translations["MSG_PARENT_PAGE_PROJECT_PUBLISH"] = "Project Visibility";
translations["MSG_PARENT_PAGE_COPY_PERMISSION"] = "Copy Permission";
translations["MSG_PARENT_PAGE_AI_CHAT"] = "Talk with Mana Pal";
translations["MSG_PARENT_PAGE_AI_GENERATION"] = "Create with AI";
translations["MSG_PARENT_PAGE_ACCOUNT_STATUS"] = "Account Status";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "Danger Zone";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] =
  "All learning data and projects will be deleted. This action cannot be undone.";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "Delete this player";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "Delete";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY"] = "Recent Activity";
translations["MSG_PARENT_PAGE_NO_ACTIVITY_24H"] = "No activity in the last 24 hours";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY_24H"] = "Activity in last 24 hours";
translations["MSG_PARENT_PAGE_TODAY"] = "Today";
translations["MSG_PARENT_PAGE_YESTERDAY"] = "Yesterday";

// Parent Page - Activity Types
translations["MSG_ACTIVITY_COURSE_CLEAR"] = "Cleared %{course} Stage %{stage} Level %{level}!";
translations["MSG_ACTIVITY_PROJECT_CREATED"] = 'Created "%{name}"';
translations["MSG_ACTIVITY_PROJECT_PUBLISHED"] = 'Published "%{name}"';
translations["MSG_ACTIVITY_PROJECT_FAVORITED"] = 'Liked "%{name}"';
translations["MSG_ACTIVITY_FAVORITED_RECEIVED"] = "Received a like";
translations["MSG_ACTIVITY_LOGIN"] = "Logged in";
translations["MSG_ACTIVITY_ICON_CHANGED"] = "Changed icon";
translations["MSG_ACTIVITY_AI_CHAT"] = "Chatted with AI";
translations["MSG_ACTIVITY_INQUIRY_SENT"] = "Sent an inquiry";
translations["MSG_ACTIVITY_APP_REVIEWED"] = "Rated the app ★%{rating}";
translations["MSG_ACTIVITY_FEEDBACK_SENT"] = "Sent feedback";
translations["MSG_ACTIVITY_COIN_EARNED"] = "Earned %{amount} coins";
translations["MSG_ACTIVITY_COIN_SPENT"] = "Spent %{amount} coins";
translations["MSG_ACTIVITY_LOGIN_STREAK"] = "%{days}-day login streak!";
translations["MSG_ACTIVITY_DEFAULT"] = "Activity";

// Parent Page - Activity Log (for parents)
translations["MSG_PARENT_PAGE_ACTIVITY_COURSE_CLEAR"] =
  "Cleared %{course} Stage %{stage} Level %{level}!";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_CREATED"] = 'Created "%{name}"';
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_PUBLISHED"] = 'Published "%{name}"';
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_FAVORITED"] = 'Liked "%{name}"';
translations["MSG_PARENT_PAGE_ACTIVITY_FAVORITED_RECEIVED"] = "Received a like";
translations["MSG_PARENT_PAGE_ACTIVITY_LOGIN"] = "Logged in";
translations["MSG_PARENT_PAGE_ACTIVITY_ICON_CHANGED"] = "Changed icon";
translations["MSG_PARENT_PAGE_ACTIVITY_AI_CHAT"] = "Chatted with AI";
translations["MSG_PARENT_PAGE_ACTIVITY_INQUIRY_SENT"] = "Sent an inquiry";
translations["MSG_PARENT_PAGE_ACTIVITY_APP_REVIEWED"] = "Rated the app ★%{rating}";
translations["MSG_PARENT_PAGE_ACTIVITY_FEEDBACK_SENT"] = "Sent feedback";
translations["MSG_PARENT_PAGE_ACTIVITY_DEFAULT"] = "Activity";

// Parent Page - Projects & Assets Section
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS"] = "Apps";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS_EMPTY"] = "No apps yet";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS"] = "Asset List";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_LIST"] = "Asset List";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_EMPTY"] = "No assets yet";
translations["MSG_PARENT_PAGE_PLAYER_SHOW_MORE"] = "Show More";
translations["MSG_PARENT_PAGE_PLAYER_ALBUM"] = "Album";
translations["MSG_PARENT_PAGE_PLAYER_SKETCHBOOK"] = "Sketchbook";
translations["MSG_PARENT_PAGE_PLAYER_AI_IMAGE"] = "AI Images";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_PUBLISHED"] = "Published";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UNPUBLISHED"] = "Private";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_VIEWS"] = " views";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_LIKES"] = " likes";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_COPIES"] = " copies";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_CREATED"] = "Created";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UPDATED"] = "Updated";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_CREATED"] = "Created";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_SIZE"] = "Size";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_UNNAMED"] = "Unnamed";

// Parent Page - Feedback History
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY"] = "Feedback History";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY_EMPTY"] = "No feedback yet";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_RATING"] = "App Rating";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_FEEDBACK"] = "Feedback";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_CONTACT"] = "Inquiry";
translations["MSG_PARENT_PAGE_FEEDBACK_RATING_SUMMARY"] = "Rated app ★%{rating}";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_HOW_TO"] = "How to use";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_BUG"] = "Bug report";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_REQUEST"] = "Feature request";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_OTHER"] = "Other";
translations["MSG_PARENT_PAGE_FEEDBACK_REPLIED"] = "Replied";
translations["MSG_PARENT_PAGE_FEEDBACK_PENDING"] = "Pending";
translations["MSG_PARENT_PAGE_FEEDBACK_DETAIL"] = "Feedback Detail";

// Parent Page - AI Chat History
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY"] = "AI Chat History";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY_EMPTY"] = "No chat history yet";
translations["MSG_PARENT_PAGE_AI_CHAT_MESSAGE_COUNT"] = "%{count} messages";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_TITLE"] = "No title";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_MESSAGES"] = "No messages";

// Parent Page - Billing Tab
translations["MSG_PARENT_PAGE_CURRENT_PLAN"] = "Current Plan";
translations["MSG_PARENT_PAGE_MONTHLY_PRICE"] = "Monthly Price";
translations["MSG_PARENT_PAGE_PLAN_COMPARISON"] = "Plan Comparison";
translations["MSG_PARENT_PAGE_USER_COUNT"] = "Players";
translations["MSG_PARENT_PAGE_PEOPLE"] = " players";
translations["MSG_PARENT_PAGE_PROJECT_COUNT"] = '"Create Freely" Projects';
translations["MSG_PARENT_PAGE_PROJECTS"] = " projects";
translations["MSG_PARENT_PAGE_AI_CHAT_FEATURE"] = "Chat with Mana Pal";
translations["MSG_PARENT_PAGE_AI_IMAGE_FEATURE"] = "AI Image Generation";
translations["MSG_PARENT_PAGE_AI_CHAT_FREE_LIMIT"] = "5/day";
translations["MSG_PARENT_PAGE_AI_IMAGE_FREE_LIMIT"] = "2/day";
translations["MSG_PARENT_PAGE_AI_CHAT_TAGLINE"] = "Have fun chatting with an AI character!";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_1"] = "Answers questions and provides advice";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_2"] =
  "A conversation experience that nurtures your child's curiosity";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_3"] = "Discuss your ideas";
translations["MSG_PARENT_PAGE_AI_IMAGE_TAGLINE"] = "Turn your imagination into images!";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_1"] = "Create original icons";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_2"] = "Use in 'Create Freely'";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_3"] = "Can also send in chat";
translations["MSG_PARENT_PAGE_UNLIMITED"] = "Unlimited";
translations["MSG_PARENT_PAGE_CHAT_HISTORY_FEATURE"] = "Chat History";
translations["MSG_PARENT_PAGE_CHAT_HISTORY_FREE_LIMIT"] = "Up to 100";
translations["MSG_PARENT_PAGE_AI_CHAT_STANDARD_LIMIT"] = "Unlimited";
translations["MSG_PARENT_PAGE_AI_CHAT_PREMIUM_LIMIT"] = "Unlimited";
translations["MSG_PARENT_PAGE_AI_IMAGE_STANDARD_LIMIT"] = "Unlimited (1 image at a time)";
translations["MSG_PARENT_PAGE_AI_IMAGE_PREMIUM_LIMIT"] = "Unlimited (3 images at a time)";
translations["MSG_PARENT_PAGE_FREE"] = "Free";
translations["MSG_PARENT_PAGE_PLAN_INFO"] = "Plan Info";
translations["MSG_PARENT_PAGE_UPGRADE_SECTION"] = "Purchase Plan";
translations["MSG_PARENT_PAGE_SELECT_BILLING_PERIOD"] = "Select Billing Period";
translations["MSG_PARENT_PAGE_ANNUAL_PRICE"] = "Annual Price";

// Parent Page - Other Tab
translations["MSG_PARENT_PAGE_DOWNLOAD_PARENTS_APP"] = "Download Parent App";
translations["MSG_PARENT_PAGE_APP_DESCRIPTION"] =
  "Use the parent app to check your child's learning progress and manage settings.";
translations["MSG_PARENT_PAGE_LEARNING_SUPPORT"] = "Learning Support";
translations["MSG_PARENT_PAGE_COURSE_ANSWER"] = "View Course Answers";
translations["MSG_PARENT_PAGE_VIEW_TUTORIAL"] = "View Tutorial";
translations["MSG_PARENT_PAGE_CORPORATE_CODE"] = "Corporate Code";
translations["MSG_PARENT_PAGE_ENABLE_CORPORATE"] = "Enter Corporate Auth Code";
translations["MSG_PARENT_PAGE_CORPORATE_DESCRIPTION"] =
  "If you have a corporate partnership code, please enter it here.";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_DESCRIPTION"] =
  "If you have a 'Manande Puzzle' authentication code (corporate partnership code), please enter the specified code below.";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_CODE_INPUT"] = "Enter Auth Code";
translations["MSG_PARENT_PAGE_CORPORATE_CONFIRM"] = "Confirm";
translations["MSG_PARENT_PAGE_CORPORATE_ALLOWED_CONTENT"] = "Allowed Content (Cassettes)";
translations["MSG_PARENT_PAGE_CORPORATE_NO_CONTENT"] = "No additional allowed content (cassettes).";
translations["MSG_PARENT_PAGE_DATE_FORMAT"] = "MM/DD";
// Parent Page - Notifications Tab (Demo Data)
// Image Generation Modal
translations["MSG_AI_PRESET_CAT"] = "Cat";
translations["MSG_AI_PRESET_DOG"] = "Dog";
translations["MSG_AI_PRESET_RABBIT"] = "Rabbit";
translations["MSG_AI_PRESET_BEAR"] = "Bear";
translations["MSG_AI_PRESET_BIRD"] = "Bird";
translations["MSG_AI_PRESET_NINJA"] = "Ninja";
translations["MSG_AI_PRESET_WIZARD"] = "Wizard";
translations["MSG_AI_PRESET_ROBOT"] = "Robot";

// AI Generation Options (Parent)
translations["MSG_OPTIONAL"] = "Optional";
translations["MSG_REQUIRED"] = "Required";
// AI Styles (9 types)
translations["MSG_AI_STYLE_CYBERPUNK"] = "Cyberpunk";
translations["MSG_AI_STYLE_ANIME"] = "Anime";
translations["MSG_AI_STYLE_DRAMATIC"] = "Dramatic Portrait";
translations["MSG_AI_STYLE_COLORING"] = "Coloring Book";
translations["MSG_AI_STYLE_PHOTO"] = "Photography";
translations["MSG_AI_STYLE_RETRO_MANGA"] = "Retro Manga";
translations["MSG_AI_STYLE_EIGHTIES"] = "80s Glamour";
translations["MSG_AI_STYLE_ART_NOUVEAU"] = "Art Nouveau";
translations["MSG_AI_STYLE_SYNTHWAVE"] = "Synthwave";

// AI Expressions (4 types)
translations["MSG_AI_EXPRESSION_SMILE"] = "Smile";
translations["MSG_AI_EXPRESSION_COOL"] = "Cool";
translations["MSG_AI_EXPRESSION_SLEEPY"] = "Sleepy";
translations["MSG_AI_EXPRESSION_SURPRISED"] = "Surprised";

// AI Accessories (4 types)
translations["MSG_AI_ACCESSORY_HAT"] = "Hat";
translations["MSG_AI_ACCESSORY_GLASSES"] = "Glasses";
translations["MSG_AI_ACCESSORY_RIBBON"] = "Ribbon";
translations["MSG_AI_ACCESSORY_CROWN"] = "Crown";

// AI Backgrounds (4 types)
translations["MSG_AI_BACKGROUND_STARRY"] = "Starry Sky";
translations["MSG_AI_BACKGROUND_MEADOW"] = "Meadow";
translations["MSG_AI_BACKGROUND_SPACE"] = "Space";
translations["MSG_AI_BACKGROUND_FLOWER"] = "Flower Field";

// AI Edit - Types
// AI Edit - Step Titles
// AI Edit - Style Options
// AI Edit - Background Options
// AI Edit - Costume Options
// AI Edit - Animal Options
// AI Edit - Accessory Options
// AI Edit - Seasonal Options
translations["MSG_TOAST_AI_GENERATION_FAILED"] = "Failed to generate AI image.";
// AIImageModal
translations["MSG_AI_IMAGE_SAVED"] = "AI image saved to assets";
translations["MSG_AI_TAB_GENERATE"] = "Generate";
// CreateUserWizard - Step names
translations["MSG_CREATE_USER_STEP_NAME"] = "Name";
translations["MSG_CREATE_USER_STEP_ICON"] = "Icon";
translations["MSG_CREATE_USER_STEP_CONFIRM"] = "Confirm";

// CreateUserWizard - Titles
translations["MSG_CREATE_USER_TITLE_GENDER"] = "Which one are you?";
translations["MSG_CREATE_USER_TITLE_BIRTHDAY"] = "When is your birthday?";
translations["MSG_CREATE_USER_TITLE_PREVIEW"] = "Does this look good?";
// CreateUserWizard - Buttons
translations["MSG_CREATE_USER_BTN_NEXT"] = "Next";
translations["MSG_CREATE_USER_BTN_GENERATE"] = "Create Icon";
// CreateUserWizard - Icon selection methods
// CreateUserWizard - Profile substep names
translations["MSG_PROFILE_SUBSTEP_GENDER"] = "Gender";
translations["MSG_PROFILE_SUBSTEP_BIRTHDAY"] = "Birthday";
translations["MSG_PROFILE_SUBSTEP_FAVORITES"] = "Favorites";
translations["MSG_PROFILE_SUBSTEP_ICON"] = "Icon";
translations["MSG_ICON_GENERATING"] = "Creating icon\nbased on your profile...";
translations["MSG_ICON_CONFIRM_PROMPT"] = "Is this icon okay?";
translations["MSG_ICON_CONFIRM_BTN"] = "Looks good!";
translations["MSG_ICON_REGENERATE_BTN"] = "Try again";
translations["MSG_ICON_CREATE_BTN"] = "Create";
translations["MSG_ICON_ADDITIONAL_PROMPT_PLACEHOLDER"] = "Add something if you want";
translations["MSG_ICON_ADDITIONAL_PROMPT_HINT"] =
  "Enter your favorite colors or things to create a new icon!";

// CreateUserWizard - Profile input titles
// CreateUserWizard - Other
// CreateUserWizard - Parent/Child addition texts
// CreateUserWizard - Parent buttons
// CreateUserWizard - Upload icon (Parent)
translations["MSG_ICON_SELECT_UPLOAD"] = "Upload Image";
translations["MSG_UPLOAD_ICON_TITLE"] = "Upload an Image";
translations["MSG_UPLOAD_ICON_SELECT"] = "Choose Image";
translations["MSG_UPLOAD_ICON_HINT"] = "JPG, PNG format, up to 5MB";
translations["MSG_UPLOAD_ICON_CHANGE"] = "Change Image";
translations["MSG_UPLOAD_ICON_REMOVE"] = "Remove Image";
// CreateUserWizard - Occupation step (Parent)
// Profile tabs
translations["MSG_PROFILE_TAB_BASIC"] = "Basic";
translations["MSG_PROFILE_TAB_APPEARANCE"] = "Avatar";
translations["MSG_PROFILE_TAB_FAVORITES"] = "Personality";
translations["MSG_PROFILE_TAB_GAME_CASE"] = "Game\nCase";
translations["MSG_PROFILE_MULTI_SELECT"] = "Select as many as you like";
translations["MSG_PROFILE_NOT_SET"] = "Not selected yet";
translations["MSG_PROFILE_SELF_INTRODUCTION_NOT_SET"] = "Not entered yet";
translations["MSG_PROFILE_CHANGE_BTN"] = "Change";
translations["MSG_PROFILE_EDIT_COLOR_TITLE"] = "Choose your favorite color";
translations["MSG_PROFILE_EDIT_BEST_SUBJECTS_TITLE"] = "Choose your best subjects";
translations["MSG_SELECT_PLACEHOLDER"] = "Select";

// CreateUserWizard - Favorites step
translations["MSG_PROFILE_AI_FAVORITE_COLOR"] = "Favorite Color";
translations["MSG_PROFILE_AI_FAVORITE_ANIMAL"] = "Favorite Animal";
translations["MSG_PROFILE_AI_FAVORITE_FOOD"] = "Favorite Food";
translations["MSG_PROFILE_AI_STRENGTH"] = "What are you good at?";
translations["MSG_PROFILE_AI_OTHER_INFO"] = "Self introduction";
translations["MSG_PROFILE_AI_OTHER_INFO_PLACEHOLDER"] = "Tell us about yourself";
translations["MSG_PROFILE_AI_BEST_SUBJECTS"] = "Best Subjects";
translations["MSG_PROFILE_AI_GLASSES"] = "Glasses";
translations["MSG_PROFILE_AI_ACCESSORY"] = "Accessories";
translations["MSG_PROFILE_AI_HAIRSTYLE"] = "Hairstyle";
translations["MSG_PROFILE_AI_BODY_TYPE"] = "Body Type";
translations["MSG_PROFILE_AI_FACE_SHAPE"] = "Face Shape";
translations["MSG_PROFILE_EDIT_ACCESSORY_TITLE"] = "Choose accessories";
// Accessory options
translations["MSG_ACCESSORY_NONE"] = "None";
translations["MSG_ACCESSORY_MEGANE"] = "Glasses";
translations["MSG_ACCESSORY_BOUSHI"] = "Hat";
translations["MSG_ACCESSORY_HAIRPIN"] = "Hairpin";
translations["MSG_ACCESSORY_RIBBON"] = "Ribbon";
translations["MSG_ACCESSORY_BANDAID"] = "Bandaid";

// Colors
translations["MSG_COLOR_RED"] = "Red";
translations["MSG_COLOR_BLUE"] = "Blue";
translations["MSG_COLOR_PINK"] = "Pink";
translations["MSG_COLOR_GREEN"] = "Green";
translations["MSG_COLOR_YELLOW"] = "Yellow";
translations["MSG_COLOR_PURPLE"] = "Purple";
translations["MSG_COLOR_WHITE"] = "White";

// Color selection UI
translations["MSG_COLOR_SELECT_SHADE"] = "Choose a shade you like";

// Animals
translations["MSG_ANIMAL_CAT"] = "Cat";
translations["MSG_ANIMAL_DOG"] = "Dog";
translations["MSG_ANIMAL_RABBIT"] = "Rabbit";
translations["MSG_ANIMAL_BEAR"] = "Bear";
translations["MSG_ANIMAL_BIRD"] = "Bird";
translations["MSG_ANIMAL_DINOSAUR"] = "Dinosaur";

// Foods
translations["MSG_FOOD_CURRY"] = "Curry";
translations["MSG_FOOD_RAMEN"] = "Ramen";
translations["MSG_FOOD_SUSHI"] = "Sushi";
translations["MSG_FOOD_HAMBURGER"] = "Hamburger";
translations["MSG_FOOD_PIZZA"] = "Pizza";
translations["MSG_FOOD_ICE_CREAM"] = "Ice Cream";
translations["MSG_FOOD_FRUIT"] = "Fruit";
translations["MSG_FOOD_CAKE"] = "Cake";

// Strengths
translations["MSG_STRENGTH_SPORTS"] = "Sports";
translations["MSG_STRENGTH_DRAWING"] = "Drawing";
translations["MSG_STRENGTH_MUSIC"] = "Music";
translations["MSG_STRENGTH_READING"] = "Reading";
translations["MSG_STRENGTH_MATH"] = "Math";
translations["MSG_STRENGTH_GAMES"] = "Games";
translations["MSG_STRENGTH_CRAFTS"] = "Crafts";
translations["MSG_STRENGTH_COOKING"] = "Cooking";

// Interests
translations["MSG_INTEREST_PROGRAMMING"] = "Programming";
translations["MSG_INTEREST_SCIENCE"] = "Science";
translations["MSG_INTEREST_ART"] = "Art";
translations["MSG_INTEREST_MUSIC"] = "Music";
translations["MSG_INTEREST_SPORTS"] = "Sports";
translations["MSG_INTEREST_NATURE"] = "Nature";
translations["MSG_INTEREST_SPACE"] = "Space";
translations["MSG_INTEREST_ANIMALS"] = "Animals";

// Subjects
translations["MSG_SUBJECT_LANGUAGE"] = "Language Arts";
translations["MSG_SUBJECT_MATH"] = "Math";
translations["MSG_SUBJECT_SCIENCE"] = "Science";
translations["MSG_SUBJECT_SOCIAL"] = "Social Studies";
translations["MSG_SUBJECT_MUSIC"] = "Music";
translations["MSG_SUBJECT_ART"] = "Art";
translations["MSG_SUBJECT_PE"] = "P.E.";
translations["MSG_SUBJECT_LIFE"] = "Life Studies";
translations["MSG_SUBJECT_HOME_EC"] = "Home Economics";
translations["MSG_SUBJECT_ETHICS"] = "Ethics";
translations["MSG_SUBJECT_ENGLISH"] = "English";
translations["MSG_SUBJECT_INTEGRATED"] = "Integrated Studies";
translations["MSG_SUBJECT_SPECIAL_ACTIVITIES"] = "Special Activities";

// Subjects (Parent)

// Appearance options
translations["MSG_GLASSES_NONE"] = "None";
translations["MSG_GLASSES_YES"] = "Yes";
translations["MSG_HAIRSTYLE_VERY_SHORT"] = "Very Short";
translations["MSG_HAIRSTYLE_SHORT"] = "Short";
translations["MSG_HAIRSTYLE_MEDIUM"] = "Medium";
translations["MSG_HAIRSTYLE_SLIGHTLY_LONG"] = "Slightly Long";
translations["MSG_HAIRSTYLE_LONG"] = "Long";
translations["MSG_BODY_TYPE_THIN"] = "Thin";
translations["MSG_BODY_TYPE_SLIGHTLY_THIN"] = "Slightly Thin";
translations["MSG_BODY_TYPE_MEDIUM"] = "Medium";
translations["MSG_BODY_TYPE_SLIGHTLY_CHUBBY"] = "Slightly Chubby";
translations["MSG_BODY_TYPE_CHUBBY"] = "Chubby";
translations["MSG_FACE_SHAPE_ROUND"] = "Round";
translations["MSG_FACE_SHAPE_OVAL"] = "Oval";
translations["MSG_FACE_SHAPE_OBLONG"] = "Oblong";
translations["MSG_FACE_SHAPE_SQUARE"] = "Square";
translations["MSG_FACE_SHAPE_TRIANGLE"] = "Triangle";

// CreateUserWizard - Parent step names
// CreateUserWizard - Profile substeps (Parent)
// CreateUserWizard - Birthday step-by-step (Child)
translations["MSG_BIRTHDAY_YEAR_SUFFIX"] = "";
translations["MSG_BIRTHDAY_MONTH_SUFFIX"] = "";
translations["MSG_BIRTHDAY_DAY_SUFFIX"] = "";
// Footer buttons
// NameInputStep
// PresetIconStep tabs
// BirthdayStep suffixes
// FavoritesStep
// Color options
// Animal options
// Food options
// Strength options
// Interest options
// IconPreviewStep
// StepProgressBar
// ProfileSubStepBar

// AI Image Generation - Usage count (FREE)
translations["MSG_AI_IMAGE_PLAN_LABEL"] = "Plan";
translations["MSG_AI_IMAGE_USAGE_TODAY"] = "Today %{remaining}/%{limit}";
translations["MSG_AI_IMAGE_UNLIMITED"] = "Unlimited";
translations["MSG_AI_IMAGE_COUNT_PER_REQUEST"] = "%{count} per request";

// ParentOnboardingModal - Parent Onboarding
translations["MSG_PARENT_ONBOARDING_NAME_PLACEHOLDER"] = "Nickname";
translations["MSG_PARENT_ONBOARDING_NICKNAME_TITLE"] = "Enter your nickname";
translations["MSG_PARENT_ONBOARDING_NICKNAME_LENGTH_LIMIT"] = "Up to 10 characters";
translations["MSG_PARENT_ONBOARDING_NICKNAME_LENGTH_ERROR"] = "Please enter within 10 characters";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET"] = "Preset\nicons";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET_TITLE"] = "Choose an icon";
translations["MSG_PARENT_ONBOARDING_REGION_TITLE"] = "Your location";
translations["MSG_TOAST_FILE_TOO_LARGE"] = "File is too large";

// CreateUserWizard - Profile "Other" input fields

translations["MSG_ICON_SELECT_TITLE"] = "Choose your icon!";
translations["MSG_ICON_SELECT_SYSTEM"] = "Preset\nIcons";
translations["MSG_ICON_SELECT_SYSTEM_DESC"] = "Choose from various characters";
translations["MSG_ICON_SELECT_PROFILE_AI"] = "Create with AI\nfrom your\nprofile";
translations["MSG_ICON_SELECT_PROFILE_AI_DESC"] = "Enter your favorites and we'll create it";
translations["MSG_ICON_SELECT_MATERIAL"] = "Choose from\nmaterials";
translations["MSG_ICON_SELECT_MATERIAL_DESC"] = "You can also upload images";
translations["MSG_SYSTEM_ICON_TITLE"] = "Choose from presets";
translations["MSG_ICON_CATEGORY_ALL"] = "All";
translations["MSG_ICON_CATEGORY_BOY"] = "Boy";
translations["MSG_ICON_CATEGORY_GIRL"] = "Girl";
translations["MSG_PROFILE_AI_APPEARANCE"] = "Appearance";
translations["MSG_PROFILE_AI_BEST_SUBJECT"] = "Best Subject";
translations["MSG_GLASSES_TITLE"] = "Glasses";
translations["MSG_HAIRSTYLE_TITLE"] = "Hairstyle";
translations["MSG_BODY_TYPE_TITLE"] = "Body Type";
translations["MSG_FACE_SHAPE_TITLE"] = "Face Shape";
translations["MSG_REGENERATE_BTN"] = "Create again";
translations["MSG_PROFILE_AI_GENERATE_BTN"] = "Create icon!";
translations["MSG_PROFILE_AI_GENERATING"] = "Creating...";
translations["MSG_PROFILE_AI_GENDER_TITLE"] = "Gender";
translations["MSG_PROFILE_AI_OPTIONS_TITLE"] = "Preferences";
translations["MSG_PROFILE_AI_BIRTHDAY_TITLE"] = "Birthday";
translations["MSG_PROFILE_AI_BIRTHDAY_SELECT"] = "Select";
translations["MSG_PROFILE_AI_OCCUPATION"] = "Occupation";
translations["MSG_PROFILE_AI_OCCUPATION_PLACEHOLDER"] = "e.g., Office worker, Self-employed";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_PARENT"] = "Favorite Color";
translations["MSG_AI_MATERIAL_MODAL_TITLE"] = "Create AI Image!";
translations["MSG_AI_MATERIAL_PROMPT_LABEL"] = "What to create?";
translations["MSG_AI_MATERIAL_PROMPT_PLACEHOLDER_1"] = "cute dog";
translations["MSG_AI_MATERIAL_PROMPT_PLACEHOLDER_2"] = "running happily";
translations["MSG_AI_MATERIAL_GENERATE_BUTTON"] = "Create!";
translations["MSG_AI_EDUCATION_LIMIT_TITLE"] = "Not available";
translations["MSG_AI_EDUCATION_LIMIT_MESSAGE"] =
  "This feature is not available in the classroom plan";
translations["MSG_USER_STOCK_AI_TAB"] = "AI Atelier";
translations["MSG_USER_STOCK_AI_TITLE"] = "AI Atelier";
translations["MSG_USER_STOCK_AI_HINT"] = "Images created with AI";
translations["MSG_USER_STOCK_AI_EMPTY"] = "No AI images yet";
translations["MSG_USER_PROFILE_EDIT_BTN"] = "Edit";
translations["MSG_TOAST_PROJECT_QUOTA_EXCEEDED"] = "App limit reached";
translations["MSG_CREATOR_APP_LIMIT"] = "Cannot create app";
translations["MSG_CREATOR_APP_LIMIT_TITLE"] = "Cannot create app";
translations["MSG_CREATOR_APP_LIMIT_MESSAGE"] =
  "Your current plan allows up to %{limit} apps\nTo create a new app, please delete an existing one";
translations["MSG_CREATOR_TUTORIAL_LIMIT"] = "Cannot run guide";
translations["MSG_CREATOR_TUTORIAL_LIMIT_TITLE"] = "Cannot run guide";
translations["MSG_CREATOR_TUTORIAL_LIMIT_MESSAGE"] =
  "Your current plan allows up to %{limit} apps\nTo run this guide, please delete an existing app";
translations["MSG_TOAST_AI_QUOTA_EXCEEDED"] = "AI limit reached for today";
translations["MSG_TOAST_AI_ACCESS_DENIED"] = "This feature is not available";
translations["MSG_TOAST_ERROR"] = "An error occurred";
translations["MSG_ERROR_NETWORK"] = "Network error";
translations["MSG_GENDER_MALE_PARENT"] = "Male";
translations["MSG_GENDER_FEMALE_PARENT"] = "Female";
translations["MSG_GENDER_OTHER_PARENT"] = "Other";
translations["MSG_GENDER_PREFER_NOT_TO_SAY"] = "Prefer not to say";
translations["MSG_GENDER_NOT_SPECIFIED"] = "Not specified";
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT_PARENT"] = "Current";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED_PARENT"] = "Selected";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_TITLE"] = "Change Language";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_MESSAGE"] = "Select display language";
translations["MSG_PARENT_PAGE_EDIT_BEST_SUBJECT"] = "Edit Best Subject";
translations["MSG_PARENT_PAGE_EDIT_GLASSES"] = "Edit Glasses";
translations["MSG_PARENT_PAGE_EDIT_HAIRSTYLE"] = "Edit Hairstyle";
translations["MSG_PARENT_PAGE_EDIT_BODY_TYPE"] = "Edit Body Type";
translations["MSG_PARENT_PAGE_EDIT_FACE_SHAPE"] = "Edit Face Shape";
translations["MSG_SUBJECT_JAPANESE"] = "Japanese";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_TITLE"] = "Cannot add player";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_MESSAGE"] =
  "You can add up to {{limit}} players on this plan.\nUpgrade your plan to add more players.";
translations["MSG_PARENT_PAGE_DELETE_CHILD_TITLE"] = "Delete player?";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MESSAGE"] =
  "{{name}} will be deleted and all data (progress, projects, etc.) will be lost.\nThis action cannot be undone.";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_TITLE"] = "Cannot delete player";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_MESSAGE"] =
  "At least 1 player is required.\nAdd another player before deleting.";
translations["MSG_SUBSCRIPTION_STORE_MANAGE_TITLE"] = "Subscription Management";
translations["MSG_SUBSCRIPTION_MANAGE_APP_STORE_MESSAGE"] =
  "Please manage your subscription purchased on App Store through App Store";
translations["MSG_SUBSCRIPTION_MANAGE_PLAY_STORE_MESSAGE"] =
  "Please manage your subscription purchased on Google Play through Google Play";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_TITLE"] = "Purchased on another platform";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_MESSAGE"] =
  "This subscription was purchased on a different platform";
translations["MSG_PARENT_PAGE_BILLING_PERIOD"] = "Billing Period";
translations["MSG_SUBSCRIPTION_MONTHLY_LABEL"] = "Monthly";
translations["MSG_SUBSCRIPTION_ANNUAL_LABEL"] = "Annual";
translations["MSG_SUBSCRIPTION_MANAGE"] = "Manage Subscription";
translations["MSG_SUBSCRIPTION_COMPARISON_RECOMMENDED"] = "Recommended";
translations["MSG_PARENT_ONBOARDING_STEP_NAME"] = "Name";
translations["MSG_PARENT_ONBOARDING_STEP_ICON"] = "Icon";
translations["MSG_PARENT_ONBOARDING_STEP_COMPLETE"] = "Confirm";
translations["MSG_PARENT_PROFILE_APPEARANCE"] = "Avatar";
translations["MSG_PARENT_PROFILE_WORK"] = "Work";
translations["MSG_PARENT_PROFILE_REGION"] = "Region";
translations["MSG_PARENT_PROFILE_FAMILY"] = "Family";
translations["MSG_HOUSEHOLD_MEMBER_MOTHER"] = "Mother";
translations["MSG_HOUSEHOLD_MEMBER_FATHER"] = "Father";
translations["MSG_HOUSEHOLD_MEMBER_GRANDMOTHER"] = "Grandmother";
translations["MSG_HOUSEHOLD_MEMBER_GRANDFATHER"] = "Grandfather";
translations["MSG_COMPANY_SIZE_TITLE"] = "Company Size";
translations["MSG_COMPANY_SIZE_SOLO"] = "Sole proprietor";
translations["MSG_COMPANY_SIZE_MICRO"] = "1-10 people";
translations["MSG_COMPANY_SIZE_SMALL"] = "11-50 people";
translations["MSG_COMPANY_SIZE_MEDIUM"] = "51-300 people";
translations["MSG_COMPANY_SIZE_LARGE"] = "301-1000 people";
translations["MSG_COMPANY_SIZE_ENTERPRISE"] = "1001+ people";
translations["MSG_INDUSTRY_TITLE"] = "Industry";
translations["MSG_INDUSTRY_IT"] = "IT/Telecom";
translations["MSG_INDUSTRY_MANUFACTURING"] = "Manufacturing";
translations["MSG_INDUSTRY_FINANCE"] = "Finance/Insurance";
translations["MSG_INDUSTRY_RETAIL"] = "Retail/Wholesale";
translations["MSG_INDUSTRY_HEALTHCARE"] = "Healthcare/Welfare";
translations["MSG_INDUSTRY_EDUCATION"] = "Education";
translations["MSG_INDUSTRY_GOVERNMENT"] = "Government/Public Service";
translations["MSG_INDUSTRY_REAL_ESTATE"] = "Real Estate";
translations["MSG_INDUSTRY_CONSTRUCTION"] = "Construction";
translations["MSG_INDUSTRY_TRANSPORTATION"] = "Transportation/Logistics";
translations["MSG_INDUSTRY_MEDIA"] = "Media/Advertising";
translations["MSG_INDUSTRY_SERVICE"] = "Service Industry";
translations["MSG_INDUSTRY_OTHER"] = "Other";
translations["MSG_OCCUPATION_TITLE"] = "Occupation";
translations["MSG_OCCUPATION_EXECUTIVE"] = "Executive/Owner";
translations["MSG_OCCUPATION_MANAGER"] = "Manager";
translations["MSG_OCCUPATION_ENGINEER"] = "Engineer/Technical";
translations["MSG_OCCUPATION_SALES"] = "Sales";
translations["MSG_OCCUPATION_MARKETING"] = "Marketing";
translations["MSG_OCCUPATION_HR"] = "HR";
translations["MSG_OCCUPATION_ACCOUNTING"] = "Accounting/Finance";
translations["MSG_OCCUPATION_RESEARCHER"] = "Researcher";
translations["MSG_OCCUPATION_TEACHER"] = "Teacher";
translations["MSG_OCCUPATION_DOCTOR"] = "Doctor";
translations["MSG_OCCUPATION_NURSE"] = "Nurse";
translations["MSG_OCCUPATION_LAWYER"] = "Lawyer";
translations["MSG_OCCUPATION_DESIGNER"] = "Designer";
translations["MSG_OCCUPATION_FREELANCE"] = "Freelancer";
translations["MSG_OCCUPATION_HOMEMAKER"] = "Homemaker";
translations["MSG_OCCUPATION_STUDENT"] = "Student";
translations["MSG_OCCUPATION_OTHER"] = "Other";
translations["MSG_JOB_TITLE_LABEL"] = "Job Title";
translations["MSG_JOB_TITLE_EXECUTIVE"] = "Executive / Board Member";
translations["MSG_JOB_TITLE_MANAGER"] = "Manager";
translations["MSG_JOB_TITLE_GENERAL"] = "General Staff";
translations["MSG_JOB_TITLE_PROFESSIONAL"] = "Professional";
translations["MSG_JOB_TITLE_HOMEMAKER"] = "No Title (Homemaker)";
translations["MSG_JOB_TITLE_STUDENT"] = "No Title (Student)";
translations["MSG_JOB_TITLE_UNEMPLOYED"] = "No Title (Unemployed)";
translations["MSG_PREFECTURE_TITLE"] = "Prefecture";
translations["MSG_CITY_TITLE"] = "City";
translations["MSG_HOUSEHOLD_MEMBERS_TITLE"] = "Household Members";
translations["MSG_BOYS_COUNT"] = "Boys";
translations["MSG_GIRLS_COUNT"] = "Girls";
translations["MSG_PARENT_ONBOARDING_INCOME_TITLE"] = "Annual Income";
translations["MSG_PARENT_ONBOARDING_INCOME_UNDER_5M"] = "Under 5M JPY";
translations["MSG_PARENT_ONBOARDING_INCOME_5M_10M"] = "5M-10M JPY";
translations["MSG_PARENT_ONBOARDING_INCOME_OVER_10M"] = "Over 10M JPY";
translations["MSG_PARENT_ONBOARDING_INCOME_PREFER_NOT_TO_SAY"] = "Prefer not to say";
translations["MSG_PARENT_ONBOARDING_OTHER_INFO_TITLE"] = "Self Introduction";
translations["MSG_PARENT_ONBOARDING_OTHER_INFO_PLACEHOLDER"] =
  "Hobbies, skills, children's ages, etc.";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_SINGLE"] = "Single parent";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_COUPLE"] = "Couple";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_NUCLEAR"] = "Nuclear family";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_EXTENDED"] = "Extended family";
translations["MSG_PARENT_ONBOARDING_HOBBIES_SPORTS"] = "Sports";
translations["MSG_PARENT_ONBOARDING_HOBBIES_MUSIC"] = "Music";
translations["MSG_PARENT_ONBOARDING_HOBBIES_READING"] = "Reading";
translations["MSG_PARENT_ONBOARDING_HOBBIES_TRAVEL"] = "Travel";
translations["MSG_PARENT_ONBOARDING_HOBBIES_COOKING"] = "Cooking";
translations["MSG_PARENT_ONBOARDING_HOBBIES_GAMING"] = "Gaming";
translations["MSG_PARENT_ONBOARDING_HOBBIES_OUTDOOR"] = "Outdoor";
translations["MSG_PARENT_ONBOARDING_HOBBIES_ART"] = "Art";
translations["MSG_PARENT_ONBOARDING_HOBBIES_MOVIES"] = "Movies";
translations["MSG_PARENT_ONBOARDING_HOBBIES_PHOTOGRAPHY"] = "Photography";
translations["MSG_PARENT_ONBOARDING_GENDER_MALE"] = "Male";
translations["MSG_PARENT_ONBOARDING_GENDER_FEMALE"] = "Female";
translations["MSG_PARENT_ONBOARDING_GENDER_NONE"] = "Not specified";
translations["MSG_PARENT_ONBOARDING_ICON_METHOD_TITLE"] = "Choose icon method";
translations["MSG_PARENT_ONBOARDING_ICON_UPLOAD"] = "Upload\nimage";
translations["MSG_PARENT_ONBOARDING_ICON_PROFILE_AI"] = "Create with AI\nfrom your\nprofile";
translations["MSG_PARENT_ONBOARDING_GENDER_TITLE"] = "Gender";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_TITLE"] = "Birthday";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_SELECT"] = "Select";
translations["MSG_PARENT_ONBOARDING_UPLOAD_TITLE"] = "Upload Image";
translations["MSG_PARENT_ONBOARDING_UPLOAD_SELECT"] = "Choose image";
translations["MSG_PARENT_ONBOARDING_UPLOAD_HINT"] = "JPG, PNG format, up to 5MB";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_TITLE"] = "Occupation (Optional)";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_OPTIONAL"] = "Optional";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_PLACEHOLDER"] = "e.g., Office worker";
translations["MSG_PARENT_ONBOARDING_ORGANIZATION_TITLE"] = "Organization";
translations["MSG_PARENT_ONBOARDING_ORGANIZATION_PLACEHOLDER"] = "Company name";
translations["MSG_PARENT_ONBOARDING_JOB_TITLE_TITLE"] = "Job Title";
translations["MSG_PARENT_ONBOARDING_JOB_TITLE_PLACEHOLDER"] = "e.g., Manager";
translations["MSG_PARENT_ONBOARDING_FAMILY_TITLE"] = "Family Structure";
translations["MSG_PARENT_ONBOARDING_CHILDREN_COUNT_TITLE"] = "Number of Children";
translations["MSG_PARENT_ONBOARDING_SPOUSE_TITLE"] = "Spouse";
translations["MSG_PARENT_ONBOARDING_SPOUSE_YES"] = "Yes";
translations["MSG_PARENT_ONBOARDING_SPOUSE_NO"] = "No";
translations["MSG_PARENT_ONBOARDING_HOBBIES_TITLE"] = "Hobbies";
translations["MSG_PARENT_ONBOARDING_HOBBIES_HINT"] = "Select all that apply";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_GENERATING"] = "Creating icon...";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_CONFIRM"] = "Is this icon okay?";
translations["MSG_PARENT_ONBOARDING_BTN_NEXT"] = "Next";
translations["MSG_PARENT_ONBOARDING_BTN_GENERATE"] = "Create";
translations["MSG_PARENT_ONBOARDING_BTN_REGENERATE"] = "Create again";
translations["MSG_PARENT_ONBOARDING_BTN_CONFIRM"] = "Confirm";
translations["MSG_PARENT_ONBOARDING_BTN_BACK"] = "Back";
translations["MSG_PARENT_ONBOARDING_BTN_COMPLETE"] = "Complete";

// Parent Page - Chat Image Restriction
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_TITLE"] = "About Image Feature";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_MESSAGE"] =
  "Sending images is available with the Premium Plan.\nUpgrade to Premium to send images.";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_BTN"] = "View Plans";

translations["MSG_AI_LABEL"] = "AI";
translations["MSG_BUILDER_MAP_NAME_PLACEHOLDER"] = "Piece name";
translations["MSG_BUILDER_TEST_BTN"] = "Test";
translations["MSG_BUILDER_ASSET_LIST_TITLE"] = "Choose Parts";
translations["MSG_BUILDER_ASSET_CATEGORY_DECORATION"] = "Decoration";
translations["MSG_BUILDER_ASSET_CATEGORY_GROUND"] = "Ground";
translations["MSG_BUILDER_ASSET_CATEGORY_GROUND_HINT"] = "Placeable at ground level";
translations["MSG_BUILDER_BLOCKLY_SETTINGS_TITLE"] = "Available Blocks";
translations["MSG_BUILDER_BLOCKLY_CATEGORY_MOTION"] = "Motion";
translations["MSG_BUILDER_BLOCKLY_CATEGORY_CONTROL"] = "Loops";
translations["MSG_BUILDER_BLOCK_MOVE_FORWARD"] = "Move Forward";
translations["MSG_BUILDER_BLOCK_TURN_LEFT"] = "Turn Left";
translations["MSG_BUILDER_BLOCK_TURN_RIGHT"] = "Turn Right";
translations["MSG_BUILDER_BLOCK_JUMP"] = "Jump";
translations["MSG_BUILDER_BLOCK_LOOP"] = "Repeat ○ times";
translations["MSG_BUILDER_BLOCK_IF_COLOR"] = "If color is ○";
translations["MSG_BUILDER_BLOCK_WHILE_COLOR"] = "Repeat until color ○";
translations["MSG_BUILDER_BLOCKLY_SELECTED_COUNT"] = "%{count} blocks selected";
translations["MSG_OK_BTN"] = "OK";
translations["MSG_BUILDER_AI_MAP_TITLE"] = "Create a Map with AI";
translations["MSG_BUILDER_AI_PROMPT_LABEL"] = "What kind of map? (Optional)";
translations["MSG_BUILDER_AI_PROMPT_PLACEHOLDER"] = "e.g., a maze-like stage";
translations["MSG_BUILDER_DIFFICULTY_LABEL"] = "Difficulty";
translations["MSG_BUILDER_DIFFICULTY_EASY"] = "Easy";
translations["MSG_BUILDER_DIFFICULTY_MEDIUM"] = "Medium";
translations["MSG_BUILDER_DIFFICULTY_HARD"] = "Hard";
translations["MSG_BUILDER_AI_GENERATING"] = "Creating...";
translations["MSG_BUILDER_AI_GENERATION_FAILED"] = "Failed to generate the map.";
// Piece Builder: PublishStepsPanel (spec §5.8.3)
translations["MSG_BUILDER_PUBLISH_PANEL_TITLE"] = "Ready to finish";
translations["MSG_BUILDER_PUBLISH_PROGRESS_DONE"] = "All set!";
translations["MSG_BUILDER_STEP_CHARACTER"] = "Character";
translations["MSG_BUILDER_STEP_GOAL"] = "Goal";
translations["MSG_BUILDER_STEP_BLOCKS"] = "Blocks";
translations["MSG_BUILDER_STEP_TEST"] = "Test";
translations["MSG_BUILDER_STEP_META"] = "Piece info";
translations["MSG_BUILDER_STEP_BLOCKS_COUNT"] = "%{count} set";
translations["MSG_BUILDER_STEP_BTN_PLACE"] = "Place";
translations["MSG_BUILDER_STEP_BTN_SETTING"] = "Set";
translations["MSG_BUILDER_STEP_BTN_RETRY"] = "Retry";
translations["MSG_BUILDER_STEP_BTN_EDIT"] = "Edit";
translations["MSG_BUILDER_EDIT_HISTORY"] = "Edit history";
translations["MSG_BUILDER_EDIT_HISTORY_EMPTY"] = "No edit history yet";
translations["MSG_BUILDER_COMPLETE_BTN"] = "Done!";
translations["MSG_BUILDER_PUBLISH_SHARE_BTN"] = "Share with everyone";
translations["MSG_BUILDER_KEEP_DRAFT_BTN"] = "Keep building";
translations["MSG_BUILDER_PUBLISH_HINT"] = "Once published, others can play it";
translations["MSG_BUILDER_COMPLETE_TOAST"] = "Completed!";
translations["MSG_BUILDER_COMPLETE_FAILED"] = "Some steps are not done yet";
// Piece Builder: Draft editing (spec §5.8.7/§5.8.8)
translations["MSG_BUILDER_DRAFT_EDITING_PILL"] = "Editing draft";
translations["MSG_BUILDER_DISCARD_DRAFT_BTN"] = "Discard draft";
translations["MSG_BUILDER_DISCARD_DRAFT_CONFIRM"] = "Stop editing?";
// Piece Builder: AIChatModal (spec §5.8.5)
translations["MSG_BUILDER_AI_CHAT_TITLE"] = "Create with AI";
translations["MSG_BUILDER_AI_CHAT_SUBTITLE"] = "Build a map by chatting";
translations["MSG_BUILDER_AI_QUOTA"] = "Today left: %{remaining}/%{limit}";
translations["MSG_BUILDER_AI_GREETING"] = "What map shall we make?";
translations["MSG_BUILDER_AI_PLAN_LABEL"] = "Idea %{n}";
translations["MSG_BUILDER_AI_USE_THIS"] = "Use this";
translations["MSG_BUILDER_AI_REGENERATE"] = "3 more ideas";
translations["MSG_BUILDER_AI_RECOMMENDED"] = "(Recommended)";
translations["MSG_BUILDER_AI_SESSION_EXPIRED"] =
  "The chat so far is gone. Let's start over from the beginning";
translations["MSG_BUILDER_AI_SEND_BTN"] = "Send";
translations["MSG_BUILDER_AI_INPUT_PLACEHOLDER"] = "Write more instructions";
// Piece Builder: BuilderTutorialOverlay (spec §5.8.6)
translations["MSG_BUILDER_TUTORIAL_STEP1_TITLE"] = "Place a character!";
translations["MSG_BUILDER_TUTORIAL_STEP1_DESC"] = "Put the character below onto the map";
translations["MSG_BUILDER_TUTORIAL_STEP2_TITLE"] = "Place a goal!";
translations["MSG_BUILDER_TUTORIAL_STEP2_DESC"] = "Next, place the goal flag";
translations["MSG_BUILDER_TUTORIAL_STEP3_TITLE"] = "Arrange blocks!";
translations["MSG_BUILDER_TUTORIAL_STEP3_DESC"] = "Place paths and plants to build the map";
translations["MSG_BUILDER_TUTORIAL_STEP4_TITLE"] = "Move it with a test!";
translations["MSG_BUILDER_TUTORIAL_STEP4_DESC"] = "Try playing with the Test button above";
translations["MSG_BUILDER_TUTORIAL_STEP5_TITLE"] = "Publish it!";
translations["MSG_BUILDER_TUTORIAL_STEP5_DESC"] = "Publish to everyone from the right panel";
translations["MSG_BUILDER_TUTORIAL_SKIP"] = "Later";
translations["MSG_BUILDER_TUTORIAL_NEXT"] = "Next";
translations["MSG_BUILDER_TUTORIAL_DONE"] = "Start";
translations["MSG_BUILDER_HELP_BTN"] = "Help";
// Piece Builder: PiecePreview (spec §5.7)
translations["MSG_BUILDER_PREVIEW_RUN"] = "Run";
translations["MSG_BUILDER_PREVIEW_RESET"] = "Reset";
translations["MSG_BUILDER_PREVIEW_MOVES"] = "Moves";
translations["MSG_BUILDER_PREVIEW_TIME"] = "Time";
translations["MSG_BUILDER_PREVIEW_BLOCK_DISABLED"] = "Not available in this piece";
translations["MSG_BUILDER_PREVIEW_CLEAR"] = "Clear!";
translations["MSG_BUILDER_PREVIEW_BACK"] = "Back";
translations["MSG_BUILDER_SAVED"] = "Saved";
translations["MSG_CHAT_NEW_BADGE"] = "New";
translations["MSG_CHAT_LOAD_MORE"] = "Load more";
translations["MSG_DASHBOARD_MAIL_EMPTY"] = "No messages yet";
translations["MSG_DASHBOARD_MAIL_IMAGE"] = "Photo";
translations["MSG_DASHBOARD_MAIL_PROJECT"] = "Project";
translations["MSG_DASHBOARD_MAIL_COURSE_CLEAR"] = "Course Clear";

translations["MSG_CHAT_SEND_FAILED_MESSAGE"] = "Failed to send the message.";

translations["MSG_CREATOR_DEFAULT_CHECK_APP"] = "Check\nApps";
translations["MSG_CREATOR_DEFAULT_CREATE_APP"] = "Create Apps";
translations["MSG_CREATOR_DEFAULT_SEARCH_APP"] = "Search Apps";

export default translations;
